<template>
  <div class="home">
    <div class="left-side">

      <section id="home">
        <div class="bg">
          <img src="@/assets/img/circle-img1.png" alt="">
        </div>
        <div class="center">
          <h1>

            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 560 216">
              <g class="Block">
                <g class="Frame 1682">
                  <path fill="#009EE0"
                        d="M0 100.137V0h68.647v16.94H20.22v23.702h41.803v16.94H20.219v42.555H0Zm162.301 0h-21.995l-8.743-22.746H91.536l-8.266 22.746H61.822L100.825 0h21.38l40.096 100.137Zm-37.227-39.618-13.798-37.158-13.525 37.158h27.323Zm42.492 39.618V0h42.554c10.701 0 18.466.91 23.293 2.732 4.872 1.776 8.765 4.964 11.68 9.563 2.914 4.6 4.371 9.859 4.371 15.779 0 7.513-2.208 13.73-6.625 18.647-4.417 4.873-11.02 7.947-19.809 9.222 4.372 2.55 7.969 5.35 10.792 8.401 2.869 3.051 6.717 8.47 11.544 16.257l12.227 19.536h-24.18l-14.618-21.79c-5.191-7.787-8.743-12.682-10.656-14.686-1.912-2.049-3.939-3.438-6.079-4.166-2.14-.775-5.533-1.162-10.178-1.162h-4.098v41.804h-20.218Zm20.218-57.787h14.959c9.7 0 15.756-.41 18.17-1.23 2.413-.82 4.303-2.231 5.669-4.235 1.366-2.003 2.049-4.508 2.049-7.513 0-3.37-.911-6.08-2.732-8.129-1.776-2.095-4.303-3.415-7.582-3.962-1.639-.227-6.557-.341-14.754-.341h-15.779v25.41Zm74.937 57.787V0h30.26l18.169 68.306L329.115 0h30.328v100.137h-18.785V21.311l-19.877 78.826h-19.467l-19.809-78.826v78.826h-18.784Zm201.508 0h-21.994l-8.743-22.746h-40.028l-8.265 22.746h-21.448L402.754 0h21.38l40.095 100.137Zm-37.226-39.618-13.798-37.158-13.525 37.158h27.323Zm42.696 39.618V0h20.219v44.467L530.765 0h27.186l-37.705 39.003L560 100.137h-26.161l-27.528-46.995-16.393 16.735v30.26h-20.219Z"
                        class="FARMAK js-scroll fade-in-bottom delay-fade-line1 scrolled"/>
                  <g class="text1 js-scroll fade-in-bottom delay-fade-line2 scrolled">
                    <path fill="#009EE0"
                          d="M535.764 104.63h10.669c2.406 0 4.24.184 5.502.552a9.675 9.675 0 0 1 4.358 2.662c1.209 1.275 2.129 2.84 2.76 4.693.631 1.841.947 4.115.947 6.823 0 2.38-.296 4.431-.887 6.153-.723 2.103-1.755 3.806-3.096 5.107-1.013.986-2.38 1.755-4.102 2.308-1.288.407-3.011.611-5.167.611h-10.984V104.63Zm5.837 4.89v19.148h4.359c1.63 0 2.806-.092 3.529-.276.947-.237 1.729-.637 2.347-1.203.631-.565 1.144-1.492 1.538-2.78.395-1.302.592-3.07.592-5.305s-.197-3.95-.592-5.147c-.394-1.196-.946-2.129-1.656-2.8-.71-.67-1.611-1.124-2.702-1.361-.815-.184-2.412-.276-4.792-.276h-2.623Zm-23.998 24.019V109.52h-8.578v-4.89h22.973v4.89h-8.558v24.019h-5.837Zm-28.042 0v-28.673h5.837v23.802h14.514v4.871h-20.351Zm-40.504 0V104.63h5.837v12.837l11.792-12.837h7.849l-10.885 11.26 11.476 17.649h-7.552l-7.947-13.567-4.733 4.831v8.736h-5.837Zm-29.303-28.909h5.837v15.657c0 2.485.072 4.095.216 4.832.25 1.183.842 2.136 1.775 2.859.947.71 2.235 1.065 3.865 1.065 1.657 0 2.906-.335 3.747-1.006.841-.683 1.348-1.518 1.518-2.504.171-.986.257-2.623.257-4.91V104.63h5.837v15.184c0 3.471-.158 5.923-.473 7.355-.316 1.433-.901 2.643-1.755 3.629-.842.986-1.972 1.775-3.392 2.366-1.42.579-3.274.868-5.561.868-2.761 0-4.858-.316-6.291-.947-1.42-.644-2.544-1.472-3.372-2.484-.828-1.026-1.374-2.097-1.637-3.215-.381-1.656-.571-4.101-.571-7.335V104.63Zm-39.617 19.502 5.679-.552c.342 1.907 1.032 3.307 2.07 4.201 1.052.894 2.465 1.341 4.24 1.341 1.88 0 3.293-.395 4.24-1.184.96-.802 1.439-1.735 1.439-2.8 0-.683-.203-1.262-.611-1.735-.394-.487-1.091-.907-2.09-1.262-.684-.237-2.242-.658-4.674-1.262-3.129-.776-5.324-1.729-6.586-2.86-1.775-1.59-2.662-3.529-2.662-5.817 0-1.472.414-2.846 1.242-4.121.841-1.289 2.044-2.268 3.609-2.939 1.577-.67 3.477-1.005 5.699-1.005 3.628 0 6.356.795 8.183 2.386 1.841 1.591 2.807 3.714 2.899 6.369l-5.837.257c-.25-1.486-.789-2.551-1.617-3.195-.815-.657-2.044-.986-3.687-.986-1.696 0-3.024.348-3.984 1.045-.618.447-.927 1.045-.927 1.795 0 .683.29 1.268.868 1.755.736.618 2.524 1.262 5.364 1.932 2.84.671 4.936 1.367 6.29 2.091 1.368.709 2.433 1.689 3.195 2.938.776 1.236 1.164 2.767 1.164 4.594 0 1.657-.461 3.208-1.381 4.654-.92 1.446-2.222 2.524-3.904 3.234-1.683.697-3.78 1.046-6.291 1.046-3.655 0-6.461-.842-8.42-2.525-1.959-1.696-3.129-4.16-3.51-7.395Zm-23.053 9.407v-28.673h5.837v23.802h14.514v4.871h-20.351Zm-3.273 0h-6.35l-2.524-6.567h-11.556l-2.386 6.567h-6.192l11.26-28.909h6.172l11.576 28.909Zm-10.747-11.437-3.984-10.728-3.904 10.728h7.888Zm-26.011.808 5.66 1.794c-.868 3.156-2.314 5.502-4.338 7.04-2.012 1.525-4.569 2.288-7.671 2.288-3.839 0-6.994-1.308-9.466-3.924-2.471-2.63-3.707-6.219-3.707-10.767 0-4.812 1.242-8.546 3.727-11.201 2.485-2.669 5.751-4.003 9.801-4.003 3.536 0 6.408 1.045 8.617 3.135 1.315 1.236 2.301 3.011 2.958 5.324l-5.778 1.381c-.342-1.499-1.058-2.682-2.149-3.55-1.078-.867-2.393-1.301-3.944-1.301-2.143 0-3.885.769-5.226 2.307-1.328 1.538-1.992 4.029-1.992 7.474 0 3.654.658 6.257 1.972 7.809 1.315 1.551 3.024 2.327 5.127 2.327 1.552 0 2.886-.493 4.004-1.479 1.117-.986 1.919-2.538 2.405-4.654Zm-29.914 10.629V104.63h5.837v28.909h-5.837Zm-18.005 0V109.52h-8.578v-4.89h22.974v4.89h-8.559v24.019h-5.837Zm-35.732-28.909h5.837v15.657c0 2.485.073 4.095.217 4.832.25 1.183.842 2.136 1.775 2.859.947.71 2.235 1.065 3.865 1.065 1.657 0 2.906-.335 3.747-1.006.841-.683 1.347-1.518 1.518-2.504.171-.986.257-2.623.257-4.91V104.63h5.837v15.184c0 3.471-.158 5.923-.474 7.355-.315 1.433-.9 2.643-1.755 3.629-.841.986-1.972 1.775-3.391 2.366-1.42.579-3.274.868-5.561.868-2.761 0-4.858-.316-6.291-.947-1.42-.644-2.544-1.472-3.372-2.484-.828-1.026-1.374-2.097-1.637-3.215-.381-1.656-.572-4.101-.572-7.335V104.63Zm-26.897 28.909V104.63h21.435v4.89h-15.598v6.409h14.513v4.871h-14.513v7.868h16.15v4.871h-21.987Zm-10.688-10.629 5.659 1.794c-.868 3.156-2.314 5.502-4.338 7.04-2.012 1.525-4.569 2.288-7.671 2.288-3.839 0-6.994-1.308-9.466-3.924-2.471-2.63-3.707-6.219-3.707-10.767 0-4.812 1.242-8.546 3.727-11.201 2.485-2.669 5.752-4.003 9.801-4.003 3.536 0 6.409 1.045 8.617 3.135 1.315 1.236 2.301 3.011 2.958 5.324l-5.778 1.381c-.341-1.499-1.058-2.682-2.149-3.55-1.078-.867-2.393-1.301-3.944-1.301-2.143 0-3.885.769-5.226 2.307-1.327 1.538-1.991 4.029-1.991 7.474 0 3.654.657 6.257 1.972 7.809 1.314 1.551 3.023 2.327 5.127 2.327 1.551 0 2.885-.493 4.003-1.479 1.117-.986 1.919-2.538 2.406-4.654Zm-21.613 10.629h-6.35l-2.524-6.567h-11.556l-2.386 6.567h-6.192l11.26-28.909h6.172l11.576 28.909Zm-10.747-11.437-3.984-10.728-3.904 10.728h7.888Zm-49.043 11.437V104.63h8.736l5.245 19.72 5.186-19.72h8.756v28.909h-5.423v-22.757l-5.739 22.757h-5.62l-5.718-22.757v22.757h-5.423Zm-29.087 0V104.63h12.285c3.09 0 5.331.263 6.725.789 1.407.512 2.531 1.433 3.372 2.76.841 1.328 1.262 2.847 1.262 4.556 0 2.169-.638 3.963-1.913 5.383-1.275 1.407-3.181 2.294-5.718 2.662 1.262.737 2.3 1.545 3.115 2.426.828.881 1.939 2.445 3.333 4.693l3.53 5.64h-6.981l-4.22-6.291c-1.499-2.248-2.524-3.661-3.076-4.239-.552-.592-1.138-.993-1.755-1.203-.618-.224-1.598-.335-2.939-.335h-1.183v12.068h-5.837Zm5.837-16.683h4.319c2.8 0 4.548-.118 5.245-.355.697-.236 1.243-.644 1.637-1.222.394-.579.592-1.302.592-2.17 0-.972-.263-1.755-.789-2.346-.513-.605-1.243-.986-2.19-1.144-.472-.066-1.892-.099-4.259-.099h-4.555v7.336Zm-8.972 16.683h-6.35l-2.524-6.567H61.762l-2.386 6.567h-6.192l11.26-28.909h6.172l11.576 28.909Zm-10.747-11.437-3.984-10.728-3.904 10.728h7.888Zm-44.488 11.437V104.63h5.837v11.378H44.23V104.63h5.837v28.909H44.23v-12.64H32.794v12.64h-5.837Zm-26.957 0V104.63h9.367c3.55 0 5.863.144 6.941.434 1.657.434 3.044 1.38 4.161 2.839 1.117 1.446 1.676 3.32 1.676 5.62 0 1.775-.322 3.267-.966 4.477-.644 1.209-1.466 2.162-2.465 2.859-.986.684-1.992 1.137-3.017 1.361-1.394.276-3.412.414-6.054.414H5.837v10.905H0Zm5.837-24.019v8.204h3.195c2.3 0 3.838-.151 4.614-.454.776-.302 1.38-.775 1.814-1.42.447-.644.67-1.393.67-2.248 0-1.051-.308-1.919-.926-2.603-.618-.683-1.4-1.111-2.347-1.281-.696-.132-2.097-.198-4.2-.198h-2.82Z"
                          class="Vector"/>
                  </g>
                  <path fill="#009EE0" d="M0 138.052h560v17.191H0z"
                        class="line1 js-scroll fade-in-bottom delay-fade-line2 scrolled"/>
                  <path fill="#009EE0" d="M0 159.242h560v10.857H0z"
                        class="line2 js-scroll fade-in-bottom delay-fade-line3 scrolled"/>
                  <path fill="#009EE0" d="M0 174.099h560v5.429H0z"
                        class="line3 js-scroll fade-in-bottom delay-fade-line4 scrolled"/>
                  <path fill="#009EE0" d="M0 183.527h560v1.81H0z"
                        class="line4 js-scroll fade-in-bottom delay-fade-line5 scrolled"/>
                </g>
                <g class="text2 fade-in-bottom delay-fade-line6 scrolled">
                  <path fill="#393B3D"
                        d="M547.808 214.952v-17.178h3.497v14.26H560v2.918h-12.192Zm-1.72 0h-3.804l-1.512-3.935h-6.923l-1.43 3.935h-3.709l6.746-17.32h3.697l6.935 17.32Zm-6.438-6.853-2.387-6.427-2.339 6.427h4.726Zm-26.388 6.853v-17.32h3.403l7.088 11.566v-11.566h3.249v17.32h-3.509l-6.982-11.295v11.295h-3.249Zm-19.334-8.554c0-1.764.264-3.245.791-4.442a8.22 8.22 0 0 1 1.607-2.374c.685-.701 1.434-1.221 2.245-1.56 1.079-.457 2.323-.685 3.733-.685 2.552 0 4.592.791 6.12 2.375 1.536 1.583 2.304 3.784 2.304 6.604 0 2.796-.76 4.985-2.28 6.569-1.52 1.575-3.553 2.362-6.097 2.362-2.575 0-4.623-.783-6.143-2.351-1.52-1.575-2.28-3.741-2.28-6.498Zm3.603-.118c0 1.961.453 3.45 1.359 4.466.906 1.008 2.056 1.512 3.45 1.512 1.394 0 2.536-.5 3.426-1.5.898-1.008 1.347-2.517 1.347-4.525 0-1.985-.438-3.465-1.312-4.442-.866-.977-2.02-1.465-3.461-1.465-1.442 0-2.603.496-3.486 1.489-.882.984-1.323 2.473-1.323 4.465Zm-9.493 8.672v-17.32h3.497v17.32h-3.497Zm-10.544 0v-14.39h-5.14v-2.93h13.764v2.93h-5.127v14.39h-3.497Zm-3.728 0h-3.804l-1.512-3.935h-6.924l-1.429 3.935h-3.71l6.746-17.32h3.698l6.935 17.32Zm-6.439-6.853-2.386-6.427-2.339 6.427h4.725Zm-26.387 6.853v-17.32h3.402l7.089 11.566v-11.566h3.249v17.32h-3.509l-6.982-11.295v11.295h-3.249Zm-17.267 0v-17.32h7.36c1.851 0 3.194.157 4.029.472.843.308 1.516.859 2.02 1.654.504.796.756 1.706.756 2.73 0 1.299-.382 2.374-1.146 3.225-.764.843-1.906 1.374-3.426 1.595.756.441 1.379.925 1.867 1.453.496.528 1.162 1.465 1.996 2.812l2.115 3.379h-4.182l-2.528-3.769c-.898-1.347-1.513-2.194-1.843-2.54-.331-.355-.682-.595-1.052-.721-.37-.134-.957-.201-1.76-.201h-.709v7.231h-3.497Zm3.497-9.995h2.587c1.678 0 2.725-.071 3.143-.213.417-.142.744-.386.981-.732.236-.347.354-.78.354-1.3 0-.583-.158-1.051-.473-1.406-.307-.362-.744-.591-1.311-.685-.284-.04-1.134-.059-2.552-.059h-2.729v4.395Zm-19.405 9.995v-17.32h12.842v2.93h-9.345v3.839h8.695v2.919h-8.695v4.713h9.676v2.919h-13.173Zm-10.651 0v-14.39h-5.139v-2.93h13.763v2.93h-5.127v14.39h-3.497Zm-21.106 0v-17.32h3.402l7.089 11.566v-11.566h3.249v17.32h-3.509l-6.983-11.295v11.295h-3.248Zm-6.634 0v-17.32h3.497v17.32h-3.497Zm-23.582 0v-17.32h3.497v7.691l7.065-7.691h4.702l-6.522 6.746 6.876 10.574h-4.525l-4.761-8.129-2.835 2.895v5.234h-3.497Zm-1.672 0h-3.804l-1.513-3.935h-6.923l-1.429 3.935h-3.71l6.746-17.32h3.698l6.935 17.32Zm-6.439-6.853-2.386-6.427-2.34 6.427h4.726Zm-29.14 6.853v-17.32h5.233l3.143 11.814 3.107-11.814h5.246v17.32h-3.249v-13.634l-3.438 13.634h-3.367l-3.426-13.634v13.634h-3.249Zm-17.184 0v-17.32h7.36c1.851 0 3.194.157 4.029.472.843.308 1.516.859 2.02 1.654.504.796.756 1.706.756 2.73 0 1.299-.382 2.374-1.146 3.225-.764.843-1.906 1.374-3.426 1.595.756.441 1.378.925 1.867 1.453.496.528 1.161 1.465 1.996 2.812l2.115 3.379h-4.182l-2.528-3.769c-.898-1.347-1.513-2.194-1.843-2.54-.331-.355-.682-.595-1.052-.721-.37-.134-.957-.201-1.76-.201h-.709v7.231h-3.497Zm3.497-9.995h2.587c1.678 0 2.725-.071 3.143-.213.417-.142.744-.386.98-.732.237-.347.355-.78.355-1.3 0-.583-.158-1.051-.473-1.406-.307-.362-.744-.591-1.311-.685-.284-.04-1.134-.059-2.552-.059h-2.729v4.395Zm-5.134 9.995h-3.804l-1.512-3.935h-6.923l-1.43 3.935h-3.709l6.746-17.32h3.697l6.935 17.32Zm-6.438-6.853-2.387-6.427-2.339 6.427h4.726Zm-22.359 6.853v-17.32h11.873v2.93h-8.376v4.099h7.23v2.93h-7.23v7.361h-3.497Zm-21.042 0v-17.32h11.873v2.93h-8.376v4.099h7.23v2.93h-7.23v7.361h-3.497Zm-19.322-8.554c0-1.764.263-3.245.791-4.442a8.22 8.22 0 0 1 1.607-2.374c.685-.701 1.433-1.221 2.245-1.56 1.079-.457 2.323-.685 3.733-.685 2.552 0 4.592.791 6.12 2.375 1.536 1.583 2.303 3.784 2.303 6.604 0 2.796-.76 4.985-2.28 6.569-1.52 1.575-3.552 2.362-6.096 2.362-2.575 0-4.623-.783-6.143-2.351-1.52-1.575-2.28-3.741-2.28-6.498Zm3.603-.118c0 1.961.453 3.45 1.359 4.466.905 1.008 2.055 1.512 3.449 1.512 1.394 0 2.536-.5 3.426-1.5.898-1.008 1.347-2.517 1.347-4.525 0-1.985-.437-3.465-1.311-4.442-.866-.977-2.02-1.465-3.462-1.465-1.441 0-2.603.496-3.485 1.489-.882.984-1.323 2.473-1.323 4.465Zm-20.038 8.672v-14.39h-5.139v-2.93h13.764v2.93h-5.128v14.39h-3.497Zm-21.13 0v-17.32h7.361c1.851 0 3.193.157 4.028.472.843.308 1.516.859 2.021 1.654.504.796.756 1.706.756 2.73 0 1.299-.382 2.374-1.146 3.225-.764.843-1.906 1.374-3.426 1.595.756.441 1.378.925 1.866 1.453.496.528 1.162 1.465 1.997 2.812l2.115 3.379h-4.183l-2.528-3.769c-.898-1.347-1.512-2.194-1.843-2.54-.331-.355-.681-.595-1.051-.721-.371-.134-.957-.201-1.761-.201h-.709v7.231h-3.497Zm3.497-9.995h2.588c1.677 0 2.725-.071 3.142-.213.418-.142.745-.386.981-.732.236-.347.354-.78.354-1.3 0-.583-.157-1.051-.472-1.406-.307-.362-.745-.591-1.312-.685-.283-.04-1.134-.059-2.552-.059h-2.729v4.395Zm-5.133 9.995h-3.804l-1.513-3.935h-6.923l-1.429 3.935h-3.71l6.746-17.32h3.698l6.935 17.32Zm-6.439-6.853-2.386-6.427-2.34 6.427h4.726Zm-23.28 6.853v-17.32h5.611c2.127 0 3.513.086 4.159.26.993.26 1.823.827 2.493 1.701.669.866 1.004 1.989 1.004 3.367 0 1.063-.193 1.957-.579 2.682-.386.725-.878 1.296-1.477 1.713-.59.41-1.193.681-1.807.815-.835.166-2.044.248-3.627.248h-2.28v6.534h-3.497Zm3.497-14.39v4.915h1.914c1.378 0 2.299-.091 2.764-.272a2.26 2.26 0 0 0 1.087-.851c.268-.386.402-.835.402-1.347 0-.63-.185-1.15-.555-1.559a2.417 2.417 0 0 0-1.406-.768c-.418-.079-1.257-.118-2.517-.118h-1.689Zm-10.716 14.39h-3.805l-1.512-3.935h-6.923l-1.429 3.935h-3.71l6.746-17.32h3.698l6.935 17.32Zm-6.439-6.853-2.387-6.427-2.339 6.427h4.726Z"
                        class="Vector"/>
                </g>
              </g>
            </svg>


          </h1>

          <h2 class="scrolled js-scroll fade-in-bottom delay-fade-line7">
            Driving quality <br>
            <span class="mr1"></span>medicines
            <br>
            <span class="mr2"></span><span class="color">worldwide</span>
          </h2>

        </div>
        <div class="text-bottom">

          <h3 class="scrolled js-scroll fade-in-bottom delay-fade-line8">Farmak is an international pharmaceutical
            company
            delivering <span>specialty generics</span> directly to
            consumers</h3>
        </div>

        <p class="scroll-down" @click="next()">
          <svg viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M6.44015 0H4.93235V12.1843L1.06618 8.31816L0 9.38434L4.62013 14.0045L4.6201 14.0045L5.68628 15.0707L11.3726 9.3844L10.3064 8.31823L6.44015 12.1845V0Z"
                  fill="#009EE0"/>
          </svg>
          scroll down
        </p>
      </section>

      <section id="about-us">
        <div class="content">
          <h2 class="js-scroll fade-in-bottom">about us</h2>
          <div class="item-wrapper">
            <div class="js-scroll fade-in-bottom item">
              <div class="icon">
                <svg width="90" height="90" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M32.1508 47.9954L27.4748 46.3949L23.4668 46.5283L25.07 42.127L23.8676 37.8591L29.2116 37.459L35.758 42.5271L32.1508 47.9954Z"
                      fill="#038FD0" stroke="#038FD0" stroke-linecap="round" stroke-linejoin="round"/>
                  <path
                      d="M53.3946 9.7168L46.5811 18.386L52.8603 17.319H59.6739L57.9371 23.8543L52.1923 31.0564L58.7386 31.4565L59.1395 32.3901L64.7506 41.8595L69.0259 43.1932L72.9003 52.5293L74.7706 55.7302L82.6531 57.1973L81.8515 62.5322L78.6451 64.9329L81.1835 69.2008L75.3051 73.4687L66.6211 73.3353L55.3986 75.736L52.4595 74.0022L48.0506 77.87L42.0386 76.9364L37.2291 80.1373L33.8891 78.5369L43.6418 69.8677L49.5203 68.0005L39.3666 66.6667L37.6298 63.3324L44.4435 60.7984L41.1035 56.3971L42.4395 51.0622L51.9251 51.8624L52.9939 47.061L48.8523 42.1263L48.7186 41.9929L41.1035 40.5258L39.6338 38.3918L42.0386 34.7908L40.0346 32.5235L36.5611 36.3912L36.4275 28.5223L33.4883 24.5211L36.0266 16.252L41.1035 9.85018L45.9131 10.3837L53.3946 9.7168Z"
                      fill="#038FD0" stroke="#038FD0" stroke-linecap="round" stroke-linejoin="round"/>
                  <path
                      d="M32.1519 47.9947L33.0872 53.8631L27.8767 61.1985L16.1199 65.9999L7.03516 64.7996L12.7799 56.2638L9.97429 47.9947L18.9255 41.5928L23.8687 37.8584L25.0712 42.1263L23.4679 46.5276L27.4759 46.3942L32.1519 47.9947Z"
                      fill="#038FD0" stroke="#038FD0" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <p class="text mb">
                <span class="big">we operate in <span class="color">the United Kingdom</span> and <span class="color">THE Republic of Ireland</span></span>
              </p>
              <p class="text ">
                <span class="color">Farmak Pharmaceuticals UK Ltd</span> is a key hub for expanding market presence,
                facilitating partnerships, and delivering high-quality pharmaceutical products across the region.
              </p>
            </div>
          </div>

          <div class="img-wrapper mob">
            <picture>
              <source type="image/webp" srcset="@/assets/img/circle-img2-mob.webp">
              <img src="@/assets/img/circle-img2-mob.png" alt="">
            </picture>
          </div>

          <div class="our-mission ">
            <div class="line3 line js-scroll width-animation2 delay-width1"></div>
            <div class="line2 line js-scroll width-animation2 delay-width2"></div>
            <div class="line1 line js-scroll width-animation2 delay-width3"></div>
            <div class="blue js-scroll fade-in-bottom">
              <h3>mission</h3>
              <p>Providing easy access to effective, high-quality medicines to contribute to the health of society</p>
            </div>

          </div>
          <div class="purpose js-scroll fade-in-bottom">
            <div class="white">
              <h3>PURPOSE & AMBITION</h3>
              <p>Become a strong global partner in the specialty care sector while maintaining high standards of
                quality, innovation, and social responsibility</p>
            </div>
          </div>
          <div class="value js-scroll fade-in-bottom">
            <p class="value__title">values</p>
            <div class="button-wrapper">
              <div class=" item item1">
                <svg width="33" height="5" viewBox="0 0 33 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="26" height="4" transform="matrix(1 0 0 -1 0 4.5)" fill="#ffffff"/>
                  <rect width="4" height="4" transform="matrix(1 0 0 -1 29 4.5)" fill="#ffffff"/>
                </svg>

                <p>QUALITY</p>
              </div>
              <div class=" item item2">
                <svg width="33" height="5" viewBox="0 0 33 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="26" height="4" transform="matrix(1 0 0 -1 0 4.5)" fill="#ffffff"/>
                  <rect width="4" height="4" transform="matrix(1 0 0 -1 29 4.5)" fill="#ffffff"/>
                </svg>

                <p>PARTNERSHIP</p>
              </div>
              <div class=" item item3">
                <svg width="33" height="5" viewBox="0 0 33 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="26" height="4" transform="matrix(1 0 0 -1 0 4.5)" fill="#ffffff"/>
                  <rect width="4" height="4" transform="matrix(1 0 0 -1 29 4.5)" fill="#ffffff"/>
                </svg>

                <p>INNOVATIONS</p>
              </div>
              <div class=" item item4">
                <svg width="33" height="5" viewBox="0 0 33 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="26" height="4" transform="matrix(1 0 0 -1 0 4.5)" fill="#ffffff"/>
                  <rect width="4" height="4" transform="matrix(1 0 0 -1 29 4.5)" fill="#ffffff"/>
                </svg>

                <p>EXPANSION</p>
              </div>
              <div class=" item item5">
                <svg width="33" height="5" viewBox="0 0 33 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="26" height="4" transform="matrix(1 0 0 -1 0 4.5)" fill="#ffffff"/>
                  <rect width="4" height="4" transform="matrix(1 0 0 -1 29 4.5)" fill="#ffffff"/>
                </svg>

                <p>SUSTAINABILITY</p>
              </div>
            </div>
          </div>

          <div class="last-line-wrapper">
            <div class="line1 last-line js-scroll width-animation2 delay-width1"></div>
            <div class="line2 last-line js-scroll width-animation2 delay-width2"></div>
            <div class="line3 last-line js-scroll width-animation2 delay-width3"></div>
          </div>
        </div>
      </section>

      <section id="management">
        <div class="content">
          <h2 class="js-scroll fade-in-bottom">managEMENT</h2>
          <h3 class="js-scroll fade-in-bottom">Marc Hourigan</h3>

          <div class="img-wrapper mob">
            <picture>
              <source type="image/webp" srcset="@/assets/img/circle-img3-mob.webp">
              <img src="@/assets/img/circle-img3-mob.png" alt="">
            </picture>

          </div>

          <div class="padding">
            <h4 class="js-scroll fade-in-bottom">Managing Director</h4>
            <p class="js-scroll fade-in-bottom">Experienced CEO, CCO, and Global Board member in the generic
              pharmaceuticals industry, with a focus on
              retail and specialized injectable products. Proven track record in operations management, brand creation,
              and driving profitability across multiple global markets.</p>
            <p class="js-scroll fade-in-bottom">Leading our strategic vision and operations with extensive industry
              expertise, Marc Hourigan drives
              innovation and growth at Farmak Pharmaceuticals UK Ltd.</p>
          </div>
        </div>
      </section>

      <section id="products">
        <div class="content">
          <h2 class="js-scroll fade-in-bottom">PRODUCTS</h2>
          <h3 class="js-scroll fade-in-bottom">Farmak is dedicated
            to deliver exceptional quality </h3>
          <h4 class="js-scroll fade-in-bottom">in every pharmaceutical<br>product we manufacture</h4>
          <a target="_blank" href="https://farmak.ch/products-uk-ireland/"
             class="mob js-scroll fade-in-bottom btn mb">view
            all products</a>
          <div class="item-wrapper">
            <div class="js-scroll fade-in-bottom item">
              <div class="icon">
                <svg width="90" height="90" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M23.4886 19.501L4.76123 67.0389" stroke="#009EE0" stroke-width="2" stroke-miterlimit="10"/>
                  <path d="M66.5107 19.501L85.2381 67.0389" stroke="#009EE0" stroke-width="2" stroke-miterlimit="10"/>
                  <path
                      d="M16.4454 67.1312V56.6489C16.4454 55.1941 17.6248 54.0146 19.0796 54.0146H21.681C23.1359 54.0146 24.3153 55.1941 24.3153 56.6489V67.1312"
                      stroke="#009EE0" stroke-width="2" stroke-miterlimit="10"/>
                  <path d="M24.3155 49.373H16.4455V53.4089H24.3155V49.373Z" stroke="#009EE0" stroke-width="2"
                        stroke-miterlimit="10"/>
                  <path
                      d="M28.7543 67.1312V56.6489C28.7543 55.1941 29.9337 54.0146 31.3886 54.0146H33.99C35.4448 54.0146 36.6243 55.1941 36.6243 56.6489V67.1312"
                      stroke="#009EE0" stroke-width="2" stroke-miterlimit="10"/>
                  <path d="M36.6244 49.373H28.7544V53.4089H36.6244V49.373Z" stroke="#009EE0" stroke-width="2"
                        stroke-miterlimit="10"/>
                  <path
                      d="M41.0654 67.1312V56.6489C41.0654 55.1941 42.2448 54.0146 43.6997 54.0146H46.3011C47.756 54.0146 48.9354 55.1941 48.9354 56.6489V67.1312"
                      stroke="#009EE0" stroke-width="2" stroke-miterlimit="10"/>
                  <path d="M48.9352 49.373H41.0653V53.4089H48.9352V49.373Z" stroke="#009EE0" stroke-width="2"
                        stroke-miterlimit="10"/>
                  <path
                      d="M53.3745 67.1312V56.6489C53.3745 55.1941 54.5539 54.0146 56.0088 54.0146H58.6102C60.0651 54.0146 61.2445 55.1941 61.2445 56.6489V67.1312"
                      stroke="#009EE0" stroke-width="2" stroke-miterlimit="10"/>
                  <path d="M61.2443 49.373H53.3744V53.4089H61.2443V49.373Z" stroke="#009EE0" stroke-width="2"
                        stroke-miterlimit="10"/>
                  <path
                      d="M65.6836 67.1312V56.6489C65.6836 55.1941 66.863 54.0146 68.3179 54.0146H70.9193C72.3741 54.0146 73.5535 55.1941 73.5535 56.6489V67.1312"
                      stroke="#009EE0" stroke-width="2" stroke-miterlimit="10"/>
                  <path d="M73.5534 49.373H65.6834V53.4089H73.5534V49.373Z" stroke="#009EE0" stroke-width="2"
                        stroke-miterlimit="10"/>
                  <path
                      d="M22.6504 49.5745V42.5463C22.6504 41.0947 23.8272 39.918 25.2788 39.918H27.8743C29.3259 39.918 30.5027 41.0947 30.5027 42.5463V49.5745"
                      stroke="#009EE0" stroke-width="2" stroke-miterlimit="10"/>
                  <path d="M30.5028 35.4893H22.6506V39.3142H30.5028V35.4893Z" stroke="#009EE0" stroke-width="2"
                        stroke-miterlimit="10"/>
                  <path
                      d="M34.9322 49.5745V42.5463C34.9322 41.0947 36.109 39.918 37.5606 39.918H40.1561C41.6077 39.918 42.7844 41.0947 42.7844 42.5463V49.5745"
                      stroke="#009EE0" stroke-width="2" stroke-miterlimit="10"/>
                  <path d="M42.7845 35.4893H34.9323V39.3142H42.7845V35.4893Z" stroke="#009EE0" stroke-width="2"
                        stroke-miterlimit="10"/>
                  <path
                      d="M47.2142 49.5745V42.5463C47.2142 41.0947 48.3909 39.918 49.8425 39.918H52.438C53.8896 39.918 55.0664 41.0947 55.0664 42.5463V49.5745"
                      stroke="#009EE0" stroke-width="2" stroke-miterlimit="10"/>
                  <path d="M55.0663 35.4893H47.2141V39.3142H55.0663V35.4893Z" stroke="#009EE0" stroke-width="2"
                        stroke-miterlimit="10"/>
                  <path
                      d="M59.4961 49.5745V42.5463C59.4961 41.0947 60.6728 39.918 62.1244 39.918H64.72C66.1716 39.918 67.3483 41.0947 67.3483 42.5463V49.5745"
                      stroke="#009EE0" stroke-width="2" stroke-miterlimit="10"/>
                  <path d="M67.3482 35.4893H59.4959V39.3142H67.3482V35.4893Z" stroke="#009EE0" stroke-width="2"
                        stroke-miterlimit="10"/>
                  <path
                      d="M29.3727 35.7521V31.1953C29.3727 29.7957 30.5073 28.6611 31.907 28.6611H34.4095C35.8091 28.6611 36.9437 29.7957 36.9437 31.1953V35.7521"
                      stroke="#009EE0" stroke-width="2" stroke-miterlimit="10"/>
                  <path d="M36.9437 24.3906H29.3727V28.0786H36.9437V24.3906Z" stroke="#009EE0" stroke-width="2"
                        stroke-miterlimit="10"/>
                  <path
                      d="M41.2132 35.7521V31.1953C41.2132 29.7957 42.3478 28.6611 43.7474 28.6611H46.25C47.6496 28.6611 48.7842 29.7957 48.7842 31.1953V35.7521"
                      stroke="#009EE0" stroke-width="2" stroke-miterlimit="10"/>
                  <path d="M48.7844 24.3906H41.2134V28.0786H48.7844V24.3906Z" stroke="#009EE0" stroke-width="2"
                        stroke-miterlimit="10"/>
                  <path
                      d="M53.056 35.7521V31.1953C53.056 29.7957 54.1907 28.6611 55.5903 28.6611H58.0928C59.4924 28.6611 60.627 29.7957 60.627 31.1953V35.7521"
                      stroke="#009EE0" stroke-width="2" stroke-miterlimit="10"/>
                  <path d="M60.6272 24.3906H53.0562V28.0786H60.6272V24.3906Z" stroke="#009EE0" stroke-width="2"
                        stroke-miterlimit="10"/>
                  <path d="M0 67.1309H90" stroke="#009EE0" stroke-width="2" stroke-miterlimit="10"/>
                  <path d="M0 70.9648H90" stroke="#009EE0" stroke-width="2" stroke-miterlimit="10"/>
                </svg>
              </div>
              <p class="text">
                <span class="big"><span class="color">Our goal is to develop and introduce products</span></span>
                across <span class="color">various healthcare sectors</span> that can make a significant impact, with a
                focus on <span class="color">addressing local
                unmet needs.</span>

              </p>
            </div>
            <div class="js-scroll fade-in-bottom item">
              <div class="icon">
                <svg width="90" height="90" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M74.3968 53.4365H80.1994V79.0367C80.1994 80.639 78.9005 81.938 77.2981 81.938C75.6958 81.938 74.3968 80.639 74.3968 79.0367V53.4365Z"
                      stroke="#009EE0" stroke-width="2"/>
                  <path
                      d="M74.3968 64.5078H80.1994V79.0366C80.1994 80.6389 78.9005 81.9378 77.2981 81.9378C75.6958 81.9378 74.3968 80.6389 74.3968 79.0365V64.5078Z"
                      stroke="#009EE0" stroke-width="2"/>
                  <rect x="72.864" y="50.332" width="8.86834" height="2.65786" rx="1.32893" stroke="#009EE0"
                        stroke-width="2"/>
                  <path
                      d="M61.6262 53.4365H67.4288V79.0367C67.4288 80.639 66.1298 81.938 64.5275 81.938C62.9251 81.938 61.6262 80.639 61.6262 79.0367V53.4365Z"
                      stroke="#009EE0" stroke-width="2"/>
                  <path
                      d="M61.6262 64.5078H67.4288V79.0366C67.4288 80.6389 66.1298 81.9378 64.5275 81.9378C62.9251 81.9378 61.6262 80.6389 61.6262 79.0365V64.5078Z"
                      stroke="#009EE0" stroke-width="2"/>
                  <rect x="60.0933" y="50.332" width="8.86834" height="2.65786" rx="1.32893" stroke="#009EE0"
                        stroke-width="2"/>
                  <path
                      d="M48.8555 53.6621H54.6581V79.0369C54.6581 80.6392 53.3591 81.9382 51.7568 81.9382C50.1545 81.9382 48.8555 80.6392 48.8555 79.0369V53.6621Z"
                      stroke="#009EE0" stroke-width="2"/>
                  <path
                      d="M48.8555 64.5225H54.6581V79.0375C54.6581 80.6398 53.3591 81.9388 51.7568 81.9388C50.1545 81.9388 48.8555 80.6398 48.8555 79.0375V64.5225Z"
                      stroke="#009EE0" stroke-width="2"/>
                  <rect x="47.3227" y="50.332" width="8.86834" height="2.65786" rx="1.32893" stroke="#009EE0"
                        stroke-width="2"/>
                  <rect x="44.4871" y="57.5478" width="38.7499" height="1.55262" stroke="#009EE0"
                        stroke-width="1.55262"/>
                  <mask id="path-11-inside-1_953_1290" fill="white">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M18.4081 18.5049C17.1218 18.5049 16.0791 19.5476 16.0791 20.8338C16.0791 22.12 17.1218 23.1627 18.4081 23.1627H29.2764C30.5626 23.1627 31.6053 22.12 31.6053 20.8338C31.6053 19.5476 30.5626 18.5049 29.2764 18.5049H18.4081ZM28.8884 47.9514V23.1628H18.7964V47.9513C11.3925 50.1285 5.98723 56.9748 5.98723 65.0835C5.98723 74.9446 13.9812 82.9386 23.8424 82.9386C33.7035 82.9386 41.6975 74.9446 41.6975 65.0835C41.6975 56.9748 36.2923 50.1286 28.8884 47.9514Z"/>
                  </mask>
                  <path
                      d="M28.8884 23.1628H30.8884V21.1628H28.8884V23.1628ZM28.8884 47.9514H26.8884V49.4479L28.3242 49.8701L28.8884 47.9514ZM18.7964 23.1628V21.1628H16.7964V23.1628H18.7964ZM18.7964 47.9513L19.3606 49.8701L20.7964 49.4479V47.9513H18.7964ZM18.0791 20.8338C18.0791 20.6522 18.2264 20.5049 18.4081 20.5049V16.5049C16.0173 16.5049 14.0791 18.443 14.0791 20.8338H18.0791ZM18.4081 21.1627C18.2264 21.1627 18.0791 21.0155 18.0791 20.8338H14.0791C14.0791 23.2246 16.0173 25.1627 18.4081 25.1627V21.1627ZM29.2764 21.1627H18.4081V25.1627H29.2764V21.1627ZM29.6053 20.8338C29.6053 21.0155 29.4581 21.1627 29.2764 21.1627V25.1627C31.6672 25.1627 33.6053 23.2246 33.6053 20.8338H29.6053ZM29.2764 20.5049C29.4581 20.5049 29.6053 20.6522 29.6053 20.8338H33.6053C33.6053 18.443 31.6672 16.5049 29.2764 16.5049V20.5049ZM18.4081 20.5049H29.2764V16.5049H18.4081V20.5049ZM26.8884 23.1628V47.9514H30.8884V23.1628H26.8884ZM18.7964 25.1628H28.8884V21.1628H18.7964V25.1628ZM20.7964 47.9513V23.1628H16.7964V47.9513H20.7964ZM7.98723 65.0835C7.98723 57.886 12.7847 51.8038 19.3606 49.8701L18.2322 46.0326C10.0002 48.4532 3.98723 56.0635 3.98723 65.0835H7.98723ZM23.8424 80.9386C15.0858 80.9386 7.98723 73.84 7.98723 65.0835H3.98723C3.98723 76.0492 12.8767 84.9386 23.8424 84.9386V80.9386ZM39.6975 65.0835C39.6975 73.84 32.5989 80.9386 23.8424 80.9386V84.9386C34.808 84.9386 43.6975 76.0492 43.6975 65.0835H39.6975ZM28.3242 49.8701C34.9001 51.8039 39.6975 57.886 39.6975 65.0835H43.6975C43.6975 56.0636 37.6845 48.4533 29.4527 46.0326L28.3242 49.8701Z"
                      fill="#009EE0" mask="url(#path-11-inside-1_953_1290)"/>
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M46.5218 44.0496C46.3849 43.9127 46.163 43.9127 46.0261 44.0496C45.8891 44.1865 45.8891 44.4085 46.0261 44.5454C46.163 44.6823 46.3849 44.6823 46.5218 44.5454C46.6588 44.4085 46.6588 44.1865 46.5218 44.0496ZM45.1076 45.4638C45.7518 46.108 46.7961 46.108 47.4403 45.4638C47.9275 44.9766 48.0462 44.2604 47.7964 43.6617L49.1616 41.2971L49.1192 41.2726C49.9829 41.4243 50.9044 41.1666 51.5716 40.4994C51.9528 40.1182 52.2003 39.654 52.3142 39.165H58.7775C58.7842 39.1938 58.7914 39.2225 58.7991 39.2513C59.1761 40.658 60.5656 41.523 61.9734 41.2721L61.9305 41.2968L63.2957 43.6614C63.1596 43.9865 63.1263 44.3575 63.2245 44.7242C63.4603 45.6041 64.3647 46.1263 65.2446 45.8905C66.1245 45.6547 66.6467 44.7503 66.4109 43.8704C66.2325 43.2045 65.6712 42.7435 65.0274 42.6608L63.6626 40.2968L63.6197 40.3216C64.1834 39.6494 64.4213 38.722 64.177 37.8103C64.0374 37.2894 63.759 36.8428 63.3923 36.4996L66.6241 30.9018C67.0355 31.027 67.4802 31.0582 67.9264 30.9772L70.9224 36.1664C70.7862 36.4916 70.7528 36.8627 70.8511 37.2296C71.0868 38.1095 71.9913 38.6317 72.8712 38.3959C73.7511 38.1601 74.2733 37.2557 74.0375 36.3758C73.8591 35.7101 73.298 35.2491 72.6544 35.1663L69.6361 29.9385C69.8112 29.7114 69.9506 29.4583 70.0489 29.1886V29.2376H72.7786C73.1722 29.7536 73.852 30.0091 74.5177 29.8307C75.3976 29.5949 75.9198 28.6905 75.684 27.8106C75.4482 26.9307 74.5438 26.4085 73.6639 26.6443C73.2971 26.7426 72.9924 26.9571 72.7789 27.2376H70.0489V27.2867C69.9489 27.0106 69.8085 26.7587 69.6364 26.5359L72.6544 21.3086C73.298 21.2257 73.8591 20.7648 74.0375 20.0991C74.2733 19.2192 73.7511 18.3148 72.8712 18.079C71.9913 17.8432 71.0868 18.3654 70.8511 19.2453C70.7528 19.6122 70.7862 19.9833 70.9224 20.3085L67.9267 25.4973C67.535 25.4264 67.1218 25.4387 66.7118 25.5486C66.6824 25.5565 66.6533 25.5648 66.6243 25.5735L63.3927 19.9761C63.7601 19.6328 64.0391 19.1857 64.1788 18.6642C64.423 17.7527 64.1854 16.8257 63.6221 16.1536L63.6637 16.1776L65.0286 13.8136C65.6724 13.7309 66.2337 13.2699 66.4121 12.6041C66.6479 11.7242 66.1257 10.8197 65.2458 10.584C64.3659 10.3482 63.4615 10.8704 63.2257 11.7503C63.1274 12.117 63.1608 12.488 63.2969 12.813L61.9317 15.1776L61.9742 15.2022C60.5668 14.9519 59.1778 15.8168 58.8009 17.2232C58.7932 17.2521 58.7859 17.281 58.7791 17.31H52.3128C52.199 16.8209 51.9514 16.3565 51.5702 15.9753C50.9028 15.3079 49.9808 15.0502 49.1169 15.2022L49.1596 15.1776L47.7944 12.813C48.0442 12.2142 47.9255 11.4981 47.4383 11.0109C46.7941 10.3667 45.7498 10.3667 45.1056 11.0109C44.4615 11.655 44.4615 12.6994 45.1056 13.3435C45.3743 13.6122 45.7126 13.7688 46.0625 13.8133L47.4275 16.1776L47.4702 16.153C46.5492 17.2467 46.6036 18.8824 47.6333 19.9122C47.6544 19.9332 47.6757 19.9539 47.6972 19.9741L44.4648 25.5728C44.4366 25.5643 44.408 25.5562 44.3793 25.5485C43.9693 25.4386 43.5562 25.4262 43.1645 25.4972L40.1685 20.308C40.3046 19.983 40.338 19.612 40.2397 19.2453C40.004 18.3654 39.0995 17.8432 38.2196 18.079C37.3397 18.3148 36.8175 19.2192 37.0533 20.0991C37.2317 20.7649 37.793 21.2259 38.4368 21.3087L41.4547 26.5358C41.2827 26.7584 41.1424 27.0101 41.0424 27.286V27.2374H38.3123C38.0989 26.9569 37.7942 26.7424 37.4274 26.6441C36.5475 26.4084 35.6431 26.9306 35.4073 27.8105C35.1715 28.6904 35.6937 29.5948 36.5736 29.8306C37.2394 30.009 37.9192 29.7535 38.3127 29.2374H41.0424V29.1889C41.1408 29.4585 41.2801 29.7115 41.4551 29.9385L38.4369 35.1662C37.793 35.249 37.2317 35.71 37.0533 36.3758C36.8175 37.2557 37.3397 38.1602 38.2196 38.3959C39.0995 38.6317 40.004 38.1095 40.2397 37.2296C40.338 36.8629 40.3046 36.492 40.1685 36.1669L43.1648 30.9772C43.6103 31.058 44.0542 31.027 44.4649 30.9023L47.6976 36.5015C47.6764 36.5215 47.6554 36.5418 47.6347 36.5625C46.6052 37.5921 46.5506 39.2273 47.471 40.321L47.4295 40.2971L46.0645 42.6614C45.7146 42.7059 45.3763 42.8625 45.1076 43.1312C44.4635 43.7753 44.4635 44.8197 45.1076 45.4638ZM49.5716 35.7474L46.0548 29.6561C46.1809 29.4428 46.2805 29.209 46.3477 28.9579C46.5495 28.2049 46.4224 27.4413 46.0545 26.8195L49.5718 20.7274C50.2942 20.7351 51.019 20.4633 51.5702 19.9122C51.7538 19.7285 51.9064 19.5256 52.028 19.31L59.0644 19.31C59.419 19.9392 60.0166 20.4309 60.7694 20.6326C61.0194 20.6996 61.2706 20.7303 61.5174 20.728L65.0355 26.8216C64.6685 27.443 64.5418 28.2058 64.7434 28.958C64.8104 29.2083 64.9095 29.4414 65.0351 29.6541L61.5177 35.7464C61.2702 35.7439 61.0183 35.7747 60.7676 35.8418C60.0146 36.0436 59.4168 36.5355 59.0623 37.165H52.0296C51.908 36.9492 51.7553 36.7462 51.5716 36.5625C51.02 36.011 50.2945 35.7392 49.5716 35.7474ZM64.7282 12.5158C64.5411 12.4657 64.4302 12.2735 64.4803 12.0864C64.5304 11.8994 64.7226 11.7884 64.9096 11.8385C65.0967 11.8886 65.2077 12.0809 65.1575 12.2679C65.1074 12.4549 64.9152 12.5659 64.7282 12.5158ZM38.9851 19.5815C39.0353 19.7685 38.9243 19.9607 38.7372 20.0108C38.5502 20.061 38.358 19.95 38.3079 19.7629C38.2578 19.5759 38.3688 19.3837 38.5558 19.3336C38.7428 19.2835 38.935 19.3944 38.9851 19.5815ZM37.3391 28.3281C37.3893 28.1411 37.2783 27.9488 37.0912 27.8987C36.9042 27.8486 36.712 27.9596 36.6619 28.1466C36.6118 28.3337 36.7228 28.5259 36.9098 28.576C37.0968 28.6261 37.289 28.5151 37.3391 28.3281ZM38.9851 36.8935C39.0353 36.7064 38.9243 36.5142 38.7372 36.4641C38.5502 36.414 38.358 36.525 38.3079 36.712C38.2578 36.899 38.3688 37.0912 38.5558 37.1414C38.7428 37.1915 38.935 37.0805 38.9851 36.8935ZM72.1056 19.5815C72.0555 19.7685 72.1665 19.9607 72.3535 20.0109C72.5406 20.061 72.7328 19.95 72.7829 19.763C72.833 19.5759 72.722 19.3837 72.535 19.3336C72.348 19.2835 72.1558 19.3945 72.1056 19.5815ZM73.7522 28.3282C73.702 28.1412 73.813 27.949 74.0001 27.8988C74.1871 27.8487 74.3793 27.9597 74.4294 28.1467C74.4795 28.3338 74.3686 28.526 74.1815 28.5761C73.9945 28.6262 73.8023 28.5152 73.7522 28.3282ZM72.1056 36.8934C72.0555 36.7064 72.1665 36.5142 72.3535 36.464C72.5406 36.4139 72.7328 36.5249 72.7829 36.7119C72.833 36.899 72.722 37.0912 72.535 37.1413C72.348 37.1914 72.1558 37.0804 72.1056 36.8934ZM46.024 12.4251C46.161 12.562 46.3829 12.562 46.5198 12.4251C46.6568 12.2882 46.6568 12.0662 46.5198 11.9293C46.3829 11.7924 46.161 11.7924 46.0241 11.9293C45.8871 12.0662 45.8871 12.2882 46.024 12.4251ZM64.4791 44.388C64.429 44.201 64.54 44.0088 64.727 43.9587C64.914 43.9085 65.1063 44.0195 65.1564 44.2066C65.2065 44.3936 65.0955 44.5858 64.9085 44.6359C64.7214 44.686 64.5292 44.5751 64.4791 44.388Z"
                        fill="#009EE0"/>
                  <path
                      d="M6.98723 65.0827C6.98723 64.8903 6.99045 64.6986 6.99684 64.5078H40.6879C40.6943 64.6986 40.6975 64.8903 40.6975 65.0827C40.6975 74.3916 33.1512 81.9379 23.8424 81.9379C14.5335 81.9379 6.98723 74.3916 6.98723 65.0827Z"
                      stroke="#009EE0" stroke-width="2"/>
                </svg>
              </div>
              <p class="text">
                <span class="big"><span class="color">Our current focus is on Hospital Products,</span></span>
                particularly in areas such as <span
                  class="color">Anesthesia, Intensive Care, Contrast Media, Hormones,</span> and others, where we
                possess
                the expertise to compete effectively.
              </p>
            </div>
          </div>
          <a target="_blank" href="https://farmak.ch/products-uk-ireland/"
             class="desk js-scroll fade-in-bottom btn">view
            all products</a>

          <div class="img-wrapper mob mb">
            <picture>
              <source type="image/webp" srcset="@/assets/img/circle-img4-mob.webp">
              <img src="@/assets/img/circle-img4-mob.png" alt="">
            </picture>
          </div>

          <a target="_blank" href="https://farmak.ch/products-uk-ireland/"
             class="mob js-scroll fade-in-bottom btn">view
            all products</a>
        </div>
      </section>

      <section id="carbon-statement">
        <div class="content">
          <h2 class="js-scroll fade-in-bottom">statements</h2>
          <h3 class="js-scroll fade-in-bottom">Carbon Emissions Statement</h3>

          <div class="padding">
            <h4 class="js-scroll fade-in-bottom">Our Commitment to Reducing Carbon Emissions</h4>
            <p class="text-black js-scroll fade-in-bottom">
              At Farmak Pharmaceuticals UK Ltd, we recognize the critical importance of addressing climate change and
              are committed to reducing our carbon footprint. As a leading player in the pharmaceutical industry, we are
              aware of the environmental impact of our operations and are dedicated to implementing sustainable
              practices that contribute to a healthier planet.
            </p>

            <p class="list-title js-scroll fade-in-bottom">Our Approach</p>
            <ul>
              <li class="js-scroll fade-in-bottom">Carbon Reduction Goals. <span class="black">We have set ambitious targets to reduce our carbon emissions across all aspects of our business. These targets align with global efforts to limit global warming and are consistent with the principles of the Paris Agreement.</span>
              </li>
              <li class="js-scroll fade-in-bottom">Energy Efficiency. <span class="black">We continuously invest in energy-efficient technologies and processes to reduce the energy consumption of our facilities. This includes the use of energy-efficient lighting, heating, and cooling systems, as well as optimizing our production processes to minimize waste.</span>
              </li>
              <li class="js-scroll fade-in-bottom">Sustainable Supply Chain. <span class="black">We work closely with our suppliers to ensure that sustainability is embedded throughout our supply chain. We encourage our partners to adopt low-carbon practices and prioritize suppliers who share our commitment to reducing environmental impact.</span>
              </li>
              <li class="js-scroll fade-in-bottom">Waste Reduction .<span class="black">We strive to minimize waste in all our operations. By reducing waste at the source, recycling materials, and carefully managing our waste disposal, we aim to lower our overall carbon footprint.</span>
              </li>
              <li class="js-scroll fade-in-bottom">Transparency and Reporting. <span class="black">We believe in transparency and accountability. Each year, or production sites publish our carbon emissions data, along with a progress report on our reduction initiatives. </span>
              </li>
            </ul>
            <p class="reg-text js-scroll fade-in-bottom">As we move forward, we will continue to explore new
              technologies and strategies to
              further reduce our carbon footprint and ensure that our operations are as sustainable as possible.
              Together with our employees, partners, and customers, we are committed to creating a greener, more
              sustainable future.</p>
            <p class="list-title no-border js-scroll fade-in-bottom"><i>Approval</i></p>
            <p class="reg-text js-scroll fade-in-bottom"><i>This statement has been approved by the Managing Director
              and is signed by Marc
              Hourigan (<a href="/pdf/Carbon_emissions_statement.pdf" download>download PDF</a>)</i></p>

          </div>


          <div class="img-wrapper mob mb">
            <picture>
              <source type="image/webp" srcset="@/assets/img/circle-img5-mob.webp">
              <img src="@/assets/img/circle-img5-mob.png" alt="">
            </picture>
          </div>
        </div>
      </section>

      <section id="slavery-statement-2024">
        <div class="content">
          <h2 class="js-scroll fade-in-bottom">statementS</h2>
          <h3 class="js-scroll fade-in-bottom">Modern Slavery Statement for the Financial Year 2024</h3>

          <div class="padding">
            <p class="text-black js-scroll fade-in-bottom">
              Farmak Pharmaceuticals UK Ltd is committed to ensuring that modern slavery and human trafficking are not
              present in our business operations or supply chains. We take a zero-tolerance approach to slavery and
              human trafficking and are committed to acting ethically and with integrity in all our business dealings
              and relationships.
            </p>

            <p class="list-title js-scroll fade-in-bottom">Policies on Modern Slavery</p>
            <p class="reg-text mb js-scroll fade-in-bottom">We have implemented several policies to ensure that slavery
              and human trafficking do
              not
              take place in our business or supply chains. </p>
            <p class="reg-text mb js-scroll fade-in-bottom">These include:</p>
            <ul>
              <li class="js-scroll fade-in-bottom">Anti-Slavery and Human Trafficking Policy. <span class="black">This policy outlines our stance on modern slavery and the measures we take to combat it.</span>
              </li>
              <li class="js-scroll fade-in-bottom">Supplier Code of Conduct. <span class="black">We expect our suppliers to share our commitment to human rights and to take steps to eliminate modern slavery within their own supply chains.</span>
              </li>
              <li class="js-scroll fade-in-bottom">Whistleblowing Policy. <span class="black">We encourage all employees, suppliers, and contractors to report any concerns related to modern slavery or human trafficking.</span>
              </li>
            </ul>

            <p class="list-title no-border js-scroll fade-in-bottom">Due Diligence Processes</p>
            <p class="reg-text mb js-scroll fade-in-bottom">We have implemented a robust due diligence process to assess
              and manage the risks of
              modern slavery in our supply chains.</p>
            <p class="reg-text mb js-scroll fade-in-bottom">This includes:</p>
            <ul>
              <li class="js-scroll fade-in-bottom">Conducting risk <span class="black">assessments to identify areas of potential vulnerability.</span>
              </li>
              <li class="js-scroll fade-in-bottom">Auditing suppliers <span class="black">to ensure compliance with our Anti-Slavery and Human Trafficking Policy.</span>
              </li>
              <li class="js-scroll fade-in-bottom">Engaging with suppliers <span class="black">to raise awareness of modern slavery issues and to ensure they are taking steps to address these risks.</span>
              </li>
            </ul>
            <p class="list-title no-border js-scroll fade-in-bottom">Training and Awareness</p>
            <p class="reg-text js-scroll fade-in-bottom">We provide training to our employees to ensure they understand
              the risks of modern
              slavery and how to identify and address potential issues. This training is also extended to key suppliers
              and partners.</p>
            <p class="list-title no-border js-scroll fade-in-bottom">Assessment and Effectiveness</p>
            <p class="reg-text js-scroll fade-in-bottom">We regularly review our policies and procedures to assess their
              effectiveness in
              combating modern slavery. We are committed to continuous improvement and to taking any necessary steps to
              address identified risks.</p>
            <p class="list-title no-border js-scroll fade-in-bottom"><i>Approval</i></p>
            <p class="reg-text js-scroll fade-in-bottom"><i>This statement has been approved by the Managing Director
              and is signed by Marc
              Hourigan</i></p>

          </div>


          <div class="img-wrapper mob mb">
            <picture>
              <source type="image/webp" srcset="@/assets/img/circle-img6-mob.webp">
              <img src="@/assets/img/circle-img6-mob.png" alt="">
            </picture>
          </div>
        </div>
      </section>

      <section id="contact" class="contact">
        <div class="content">
          <h2 class="">
            <span class="line1">Contact us</span>
          </h2>

          <div class="contact-info">
            <div class="item">
              <h3>General<br> Enquiries</h3>
              <a href="mailto:info@farmak.uk">info@farmak.uk</a>
              <a href="mailto:customer.service@farmak.uk">customer.service@farmak.uk</a>
              <a href="tel:+44(0)1482738200">+44 (0)1482 738200</a>
            </div>
            <div class="item">
              <h3>Medical<br> Information Team</h3>
              <a href="mailto:med.info@farmak.uk">med.info@farmak.uk</a>
              <a href="tel:+44(0)1482738200">+44 (0)1482 738200</a>
            </div>
            <div class="item">
              <h3>Adverse Event<br> (side effect)</h3>
              <a href="mailto:pv@farmak.uk">pv@farmak.uk</a>

              <a href="tel:+44(0)1482738200">+44 (0)1482 738200</a>
            </div>
            <div class="item">
              <h3>Quality<br> Issue/Complaint</h3>
              <a href="mailto:quality@farmak.uk">quality@farmak.uk</a>
              <a href="tel:+44(0)1482738200">+44 (0)1482 738200</a>
            </div>
            <div class="item">
              <h3>Business<br> Development</h3>
              <a href="mailto:bd@farmak.uk">bd@farmak.uk</a>
              <a href="tel:+44 (0)1482 738200">+44 (0)1482 738200</a>
            </div>
            <div class="item">
              <h3>Accounts</h3>
              <a href="mailto:accounts@farmak.uk">accounts@farmak.uk</a>
              <a href="tel:+44(0)1482738200">+44 (0)1482 738200</a>
            </div>
          </div>

          <div class="contact-bottom mob">
            <div class="mark"></div>
            <div class="line">
              <p class="address">
                Farmak Pharmaceuticals UK Ltd<br>
                First Floor, Wykeland House<br>
                47 Queen Street<br>
                Hull, HU1 1UU<br>
                United Kingdom
              </p>
              <a class="mail" href="mailto:info@farmak.uk ">info@farmak.uk</a>
            </div>
          </div>
        </div>
      </section>

    </div>

    <div class="right-side">
      <div class="right-side__country-switch-wrapper">
        <p>Country</p>
        <div class="right-side__country-switch">
          <div @click="drop = !drop" class=" show" v-bind:class="[{ active: drop }]">Uk
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 10.6286L4 5.37138L12 5.37138L8 10.6286Z" fill="white"/>
            </svg>
          </div>
          <div class="hide" v-if="drop">
            <a @click="drop = false" href="https://www.farmak.co.cz/" target="_blank">Czechia</a>
            <a @click="drop = false" href="https://farmakinternational.pl/" target="_blank">Poland</a>
            <a @click="drop = false" href="https://farmak.sk/" target="_blank">Slovakia</a>
            <a @click="drop = false" href="https://farmak.es/" target="_blank">Spain</a>
            <a @click="drop = false" href="https://www.farmak.ch/" target="_blank">Switzerland</a>
            <a @click="drop = false" href="https://farmak.ae/" target="_blank">UAE</a>
            <a @click="drop = false" href="https://farmak.ua/en/worldwide/" target="_blank">Ukraine</a>
          </div>
        </div>
      </div>
      <Transition>
        <picture v-if="getActiveLink ==='home'">
          <source type="image/webp" srcset="@/assets/img/circle-img1.webp">
          <img src="@/assets/img/circle-img1.png" alt="">

        </picture>
      </Transition>

      <Transition>
        <picture v-if="getActiveLink ==='about-us'">
          <source type="image/webp" srcset="@/assets/img/circle-img2.webp">
          <img src="@/assets/img/circle-img2.png" alt="">

        </picture>
      </Transition>

      <Transition>
        <picture v-if="getActiveLink ==='management'">
          <source type="image/webp" srcset="@/assets/img/circle-img3.webp">
          <img src="@/assets/img/circle-img3.png" alt="">
        </picture>
      </Transition>
      <Transition>
        <picture v-if="getActiveLink ==='products'">
          <source type="image/webp" srcset="@/assets/img/circle-img4.webp">
          <img src="@/assets/img/circle-img4.png" alt="">
        </picture>
      </Transition>
      <Transition>
        <picture v-if="getActiveLink ==='carbon-statement'">
          <source type="image/webp" srcset="@/assets/img/circle-img5.webp">
          <img src="@/assets/img/circle-img5.png"
               alt="">
        </picture>
      </Transition>
      <Transition>
        <picture v-if="getActiveLink ==='slavery-statement-2024'">
          <source type="image/webp" srcset="@/assets/img/circle-img6.webp">
          <img src="@/assets/img/circle-img6.png"
               alt="">
        </picture>
      </Transition>
      <Transition>
        <picture v-if="getActiveLink ==='contact'">
          <source type="image/webp" srcset="@/assets/img/circle-img7.webp">
          <img src="@/assets/img/circle-img7.png"
               alt="">
        </picture>
      </Transition>
      <div class="right-side__info">
        <div class="mark"></div>
        <div class="line">
          <p class="address">
            Farmak Pharmaceuticals UK Ltd<br>
            First Floor, Wykeland House<br>
            47 Queen Street<br>
            Hull, HU1 1UU<br>
            United Kingdom
          </p>
          <a class="mail" href="mailto:info@farmak.uk ">info@farmak.uk</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import {mapActions, mapGetters} from "vuex";

export default {
  name: 'HomeView',

  computed: {
    ...mapGetters(['getActiveLink'])
  },

  data: () => ({
    drop: false
  }),

  methods: {
    ...mapActions(['switchLink']),

    next() {

      if (window.matchMedia("(min-width: 1080px)").matches) {
        window.scrollTo({
          top: document.getElementById('about-us').offsetTop - 62,
          left: 0,
          behavior: "smooth",
        });
      } else if (window.matchMedia("(max-width: 1079px)").matches) {
        window.scrollTo({
          top: document.getElementById('about-us').offsetTop - 62,
          left: 0,
          behavior: "smooth",
        });
      }
    },

  },

  mounted() {
    const headings = document.querySelectorAll('section');

    const scrollElements = document.querySelectorAll(".js-scroll");

    const elementInView = (el, dividend = 1) => {
      const elementTop = el.getBoundingClientRect().top;

      return (
          elementTop <=
          (window.innerHeight || document.documentElement.clientHeight) / dividend
      );
    };

    const elementOutofView = (el) => {
      const elementTop = el.getBoundingClientRect().top;

      return (
          elementTop > (window.innerHeight || document.documentElement.clientHeight)
      );
    };

    const displayScrollElement = (element) => {
      element.classList.add("scrolled");
    };

    const hideScrollElement = (element) => {
      element.classList.remove("scrolled");
    };

    const handleScrollAnimation = () => {
      scrollElements.forEach((el) => {
        if (elementInView(el, 1.1)) {
          displayScrollElement(el);
        } else if (elementOutofView(el)) {
          hideScrollElement(el)
        }
      })
    }
    if (window.matchMedia("(min-width: 861px)").matches) {
      window.addEventListener("scroll", () => {

        handleScrollAnimation()

        headings.forEach(ha => {
          const rect = ha.getBoundingClientRect();

          if (rect.top + 200 < window.innerHeight && rect.bottom - 200 >= 0) {
            const location = window.location.toString().split('#')[0];
            this.switchLink(ha.id);
            history.replaceState(null, null, location + '#' + ha.id);
          }
        });
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/styles";

.js-scroll {
  opacity: 0;
  @media screen and (max-width: 1024px) {
    opacity: 1;
  }
}

.scrolled.fade-in-bottom {
  animation: fade-in-bottom .6s ease-in-out both;

  &.delay-fade1 {
    animation-delay: .5s;
  }

  &.delay-fade-line1 {
    animation-delay: .1s;
  }

  &.delay-fade-line2 {
    animation-delay: .15s;
  }

  &.delay-fade-line3 {
    animation-delay: .20s;
  }

  &.delay-fade-line4 {
    animation-delay: .25s;
  }

  &.delay-fade-line5 {
    animation-delay: .40s;
  }

  &.delay-fade-line6 {
    animation-delay: .40s;
  }

  &.delay-fade-line7 {
    animation-delay: .7s;
  }

  &.delay-fade-line8 {
    animation-delay: .9s;
  }

  &.delay-fade2 {
    animation-delay: .6s;
  }

  &.delay-fade3 {
    animation-delay: 1200ms;
  }

  &.delay-fade4 {
    animation-delay: 1400ms;
  }

  &.delay-fade5 {
    animation-delay: 1500ms;
  }

  @media screen and (max-width: 1024px) {
    animation: none;
  }
}

.scrolled.width-animation {
  animation: width-animation .6s ease-in-out both;

  &.delay-width1 {
    animation-delay: 900ms;
  }

  &.delay-width2 {
    animation-delay: 1000ms;
  }

  &.delay-width3 {
    animation-delay: 1100ms;
  }

  &.delay-width4 {
    animation-delay: 1200ms;
  }

  @media screen and (max-width: 1024px) {
    animation: none;
  }
}

.scrolled.width-animation2 {
  animation: width-animation .6s ease-in-out both;

  &.delay-width1 {
    animation-delay: 100ms;
  }

  &.delay-width2 {
    animation-delay: 200ms;
  }

  &.delay-width3 {
    animation-delay: 300ms;
  }

  @media screen and (max-width: 1024px) {
    animation: none;
  }
}

.scrolled.rotate-animation {
  animation: rotate-animation .8s ease-in-out both;

  @media screen and (max-width: 1024px) {
    animation: none;
  }
}

@keyframes fade-in-bottom {
  0% {
    transform: translateY(30px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes width-animation {
  0% {
    width: 0;
    opacity: 0;
  }
  100% {
    width: 100%;
    opacity: 1;
  }
}

@keyframes rotate-animation {
  0% {
    opacity: 0;
    transform: rotate(0deg);
  }
  100% {
    opacity: 1;
    transform: rotate(360deg);
  }
}

.home {
  display: flex;
  justify-content: center;
  width: 100%;

  .left-side {
    max-width: 50%;
    min-width: 50%;
    width: 100%;

    @media screen and (max-width: 1080px) {
      max-width: 100%;
      min-width: 1px;
    }
  }

  .right-side {

    display: flex;
    flex-direction: column;

    max-width: 50%;
    min-width: 50%;
    width: 100%;

    position: sticky;
    position: -webkit-sticky;
    top: 0;
    left: 0;
    min-height: calc((var(--vh, 1vh) * 100));
    max-height: calc((var(--vh, 1vh) * 100));
    height: 100%;
    background: $blue-50;

    padding: 0 40px;

    @media screen and (max-width: 1080px) {
      display: none;
    }

    .wrapper {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: auto 0;
      max-width: 680px;
      max-height: 680px;
      width: 100%;

      .text-block {
        position: absolute;
        bottom: 115px;
        padding: 10px;
        background: $blue-80;
        max-width: 208px;

        width: 100%;

        line-height: 120%; /* 19.2px */
        text-transform: uppercase;
        font-family: $reg;
        font-size: 16px;
        color: white;
        @media screen and (max-height: 750px) {
          bottom: 160px;
        }


        &.text-block1 {
          left: 40px;
        }

        &.text-block2 {
          right: 40px;
        }
      }
    }

    picture {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: auto 0;
      max-width: 680px;
      width: 100%;

      img {
        //position: absolute;
        //top: 50%;
        //left: 50%;
        //
        //transform: translate(-50%, -50%);
        margin-top: -60px;
        max-height: 680px;
        min-width: 1px;
        width: auto;
        height: 100%;
        display: block;
        padding: 40px;
        object-fit: contain;
        overflow: visible;
        @media screen and (max-height: 750px) {
          margin-top: 0;
        }
      }
    }

    &__info {
      margin: auto 0 0 0;
      max-width: 600px;
      width: 100%;
      background: rgba(0, 158, 224, 0.50);
      padding-top: 10px;
      padding-bottom: 44px;
      position: relative;

      .mark {
        width: 16px;
        height: 16px;

        background: $crimson;
        border-radius: 50%;
        margin-bottom: 15px;
      }

      .line {
        width: 100%;
        padding-bottom: 16px;
        margin-bottom: 24px;
        border-bottom: 2px solid $white;

        display: flex;
        justify-content: space-between;
        align-items: flex-end;

        &.active {
          justify-content: center;
        }

        &:last-child {
          border-bottom: 0;
          padding-bottom: 0;
          margin-bottom: 0;
        }
      }

      .address {
        color: $white;
        font-size: 16px;
        font-family: $bold;
        line-height: 120%;
        //letter-spacing: -0.04em;
        margin-right: 15px;
      }

      .mail {
        border: 2px solid rgba(255, 255, 255, 0);
        transition: border-color .2s ease;
        border-radius: 44px;
        padding: 17px 35px;

        text-decoration: none;
        color: $white;
        font-size: 12px;
        font-family: $bold;
        text-transform: uppercase;
        background: rgba(255, 255, 255, 0.2);

        letter-spacing: -0.02em;

        height: 52px;

        display: flex;
        justify-content: center;
        align-items: center;

        &.active {
          font-size: 22px;
          height: 66px;
          padding: 22px 40px;

        }

        @media screen and (max-width: 1280px) {
          padding: 12px 20px;
          height: 48px;
        }

        @media screen and (min-width: 1240px) {
          &:hover {
            border-color: $white;
          }
        }
      }

      .sales-mail {
        position: relative;
        font-size: 18px;
        line-height: 120%;
        font-family: $bold;
        color: $white;

        display: inline-flex;
        align-items: center;
        text-decoration: none;
        //letter-spacing: -0.04em;
        p {
          display: flex;
          align-items: center;
          transition: transform .2s ease;
        }

        @media screen and (min-width: 1240px) {
          &:hover {
            p {
              transform: translateY(-2px);
            }
          }
        }

        svg {
          display: block;
          width: 21px;
          height: auto;
          margin-left: 10px;
        }

        &:before {
          content: '';
          width: 100%;
          height: 2px;
          bottom: -4px;
          left: 0;
          right: 0;
          position: absolute;

          background: $white;
        }
      }
    }

    &__country-switch-wrapper {
      max-width: 600px;
      position: absolute;
      width: 100%;
      left: 0;
      top: 24px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      z-index: 10;

      p {
        line-height: 136%;
        font-family: $bold;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.6);
        text-transform: uppercase;
        padding: 4px 6px;
      }
    }

    &__country-switch {
      position: relative;

      .show {
        color: white;
        font-size: 12px;
        line-height: 136%;
        font-family: $bold;
        text-transform: uppercase;
        padding: 8px 12px;
        min-width: 110px;

        display: flex;
        align-items: center;
        cursor: pointer;

        &.active {
          color: $black-100;
          background: rgba(255, 255, 255, 1);

          svg {
            transform-origin: center;
            transform: rotate(180deg);

            path {
              fill: $black-100;
            }
          }
        }

        svg {
          display: block;
          width: 16px;
          height: auto;
          margin-left: 9px;
        }
      }

      .hide {
        position: absolute;
        top: 100%;
        left: 0;

        display: flex;
        flex-direction: column;
        background: #26ADE5;
        width: 100%;

        a {
          padding: 8px 12px;
          text-transform: uppercase;

          text-decoration: none;
          color: white;
          font-size: 12px;
          font-family: $bold;
          line-height: 136%;

          @media screen and (min-width: 1240px) {
            &:hover {
              background: rgba(255, 255, 255, 0.30);
            }
          }
        }
      }
    }
  }
}

#home {
  min-height: calc(((var(--vh, 1vh) * 100) - 79px));
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 78px 80px 0 40px;
  background: $black-10;

  @media screen and (max-width: 1080px) {
    min-height: 0;
    align-items: center;
    padding: 62px 0 0 0;
  }

  .bg {
    display: none;
    background: $blue-50;
    margin: 0 -20px;
    width: 100%;
    max-height: calc(((var(--vh, 1vh) * 30)));
    height: 100%;
    overflow: hidden;
    position: relative;

    img {
      display: block;
      width: calc(100% - 40px);
      height: 100%;
      margin-top: 50px;
      max-height: calc(((var(--vh, 1vh) * 48)));
      object-fit: contain;
    }

    @media screen and (max-width: 1080px) {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .center {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: calc(((var(--vh, 1vh) * 100) - 174px - 58px));
    max-width: 560px;
    width: 100%;

    @media screen and (max-width: 1330px) {
      min-height: calc(((var(--vh, 1vh) * 100) - 174px - 72px));
    }
    @media screen and (max-width: 1091px) {
      min-height: calc(((var(--vh, 1vh) * 100) - 174px - 96px));
    }

    @media screen and (max-width: 1080px) {
      max-width: 420px;
      padding: 20px 20px 0 20px;
      min-height: 0;
      min-height: calc(((var(--vh, 1vh) * 100) - 277px - 81px - 60px - 54px - 63px));
    }
  }

  .scroll-down {
    color: $blue-50;
    font-family: $bold;
    font-size: 12px;
    margin: auto 0 40px 0;
    padding-top: 40px;

    display: flex;
    align-items: center;
    cursor: pointer;

    max-width: 560px;
    width: 100%;

    text-transform: uppercase;
    transition: color .2s ease;

    @media screen and (max-width: 1080px) {
      display: none;
    }

    @media screen and (min-width: 1240px) {
      &:hover {
        color: $blue-80;

        svg {
          path {
            fill: $blue-80;
          }
        }
      }
    }

    svg {
      width: 12px;
      height: auto;
      display: block;
      margin-right: 12px;

      path {
        transition: fill .2s ease;
      }
    }
  }

  h1 {
    color: $blue-50;
    font-family: $bold;
    letter-spacing: -0.04em;

    span {
      display: inline-block;

      &.small {
        font-size: 80px;
        line-height: 78%;
        min-width: 277px;
        width: 100%;
        display: inline-block;

        @media screen and (max-width: 1180px) {
          font-size: 70px;
          min-width: 247px;
        }

        @media screen and (max-width: 1080px) {
          font-size: 40px;
        }

        &.m-l {
          margin-left: 20px;
          @media screen and (max-width: 1230px) {
            margin-left: 16px;
          }
        }
      }

      &.big {
        font-size: 135px;
        line-height: 78%;
        text-transform: uppercase;
        margin-bottom: 8px;

        @media screen and (max-width: 1360px) {
          font-size: 120px;
        }
        @media screen and (max-width: 1180px) {
          font-size: 100px;
        }

        @media screen and (max-width: 1080px) {
          font-size: 64px;
        }
      }

      &.bottom {
        display: flex;
        align-items: center;
      }

      &.line-wrapper {
        max-width: 258px;
        width: 100%;
        display: flex;
        margin-left: 10px;
        flex-direction: column;

        @media screen and (max-width: 1230px) {
          max-width: 60%;
        }

        @media screen and (max-width: 1080px) {
          margin-left: 4px;
        }

        > span {
          width: 100%;
          margin-bottom: 7px;
          background: $blue-50;
          @media screen and (max-width: 1080px) {
            margin-bottom: 3px;
          }

          &:last-child {
            margin-bottom: 0;
          }
        }
      }

      &.line1 {
        height: 16px;
        @media screen and (max-width: 1080px) {
          height: 8px;
        }
      }

      &.line2 {
        height: 10px;
        @media screen and (max-width: 1080px) {
          height: 5px;
        }
      }

      &.line3 {
        height: 5px;
        @media screen and (max-width: 1080px) {
          height: 2px;
        }
      }

      &.line4 {
        height: 2px;
        @media screen and (max-width: 1080px) {
          height: 1px;
        }
      }
    }
  }

  h2 {
    margin-top: 60px;
    color: var(--black-80, #393B3D);
    font-family: $bold;
    font-size: 56px;
    font-style: normal;
    line-height: 100%;
    letter-spacing: -2.24px;
    text-transform: uppercase;

    .mr1 {
      margin-right: 17%;

      @media screen and (max-width: 1080px) {
        margin-right: 20%;
      }
    }

    .mr2 {
      margin-right: 37%;

      @media screen and (max-width: 1080px) {
        margin-right: 37%;
      }
    }

    @media screen and (max-width: 1280px) {
      font-size: 48px;
    }

    @media screen and (max-width: 1080px) {
      font-size: 32px;
    }

    .color {
      color: $blue-60;
    }
  }

  h3 {
    color: var(--black-80, #393B3D);
    font-family: $bold;
    font-size: 24px;
    font-style: normal;
    line-height: 100%;
    letter-spacing: -0.96px;


    @media screen and (max-width: 1080px) {
      font-size: 18px;
    }

    span {
      color: var(--Blue-60, #038FD0);
    }
  }

  .text-bottom {
    max-width: 560px;
    width: 100%;
    margin-top: auto;
    margin-bottom: 10px;


    @media screen and (max-width: 1080px) {
      max-width: 420px;
      padding: 0 20px;
      margin-bottom: 60px;
      margin-top: 81px;
    }
  }
}

.img-wrapper {
  padding: 10px 50px;
  display: none;
  max-width: 380px;
  width: 100%;
  margin: 24px 0;
  background: var(--Blue-50, #009EE0);

  &.mb {
    margin-bottom: 0;
  }

  img {
    width: 100%;
    height: auto;
    display: block;
  }

  @media screen and (max-width: 1080px) {
    display: block;
  }
}

#about-us {
  padding: 0 40px;
  display: flex;
  justify-content: flex-end;
  background: white;
  min-height: calc(((var(--vh, 1vh) * 100) - 79px));

  @media screen and (max-width: 1080px) {
    justify-content: center;
    padding: 0 20px;
    min-height: 0;
  }

  .content {
    max-width: 600px;
    width: 100%;
    padding-top: 120px;
    padding-bottom: 80px;
    margin: auto 0;

    @media screen and (max-width: 1080px) {
      padding-top: 80px;
      max-width: 380px;
      padding-bottom: 80px;
    }
  }

  h2 {
    color: #63666A;
    font-size: 32px;
    font-family: $bold;
    margin-bottom: 30px;
    text-transform: uppercase;
    letter-spacing: -1.6px;
    @media screen and (max-width: 1080px) {
      font-size: 24px;
      margin-bottom: 24px;
    }
  }


  .item-wrapper {
    display: flex;
    flex-direction: column;

    .item {
      padding: 50px 60px;
      background: #F1F1F1;
      display: flex;
      flex-direction: column;
      margin-bottom: 4px;
      @media screen and (max-width: 1240px) {
        padding: 32px;
      }

      &:last-child {
        margin-bottom: 0;
      }

      .icon {
        max-width: 90px;
        min-width: 90px;
        width: 100%;
        margin-right: 24px;
        margin-bottom: 16px;


        svg {
          width: 100%;
          height: auto;
          display: block;
        }
      }

      .text-wrapper {
        display: flex;
        align-items: center;

        @media screen and (max-width: 1080px) {
          flex-direction: column;
          align-items: flex-start;
        }
      }

      .text {
        color: #231F20;
        font-size: 20px;
        line-height: 120%;
        font-family: $bold;
        @media screen and (max-width: 1080px) {
          font-size: 18px;
        }

        .color {
          color: #038FD0;
        }

        &.mb {
          margin-bottom: 35px;
        }

        .big {
          letter-spacing: -0.72px;
          font-size: 24px;
          color: #231F20;
          text-transform: uppercase;
          @media screen and (max-width: 1080px) {
            font-size: 20px;
            letter-spacing: 0;
          }
        }
      }
    }
  }

  .button-wrapper {
    transition: transform .2s ease;
    width: 100%;

    @media screen and (max-width: 1080px) {
    }
    //@media screen and (min-width: 1080px) {
    //  &:hover {
    //    transform: scale(.83);
    //  }
    //}


    .item {
      border: 1px solid var(--blue-50, #ffffff);
      padding: 16px 24px;
      display: flex;
      align-items: center;

      //cursor: pointer;
      transform-origin: center;
      background: #009EE0;


      transition: transform .2s ease;
      overflow: hidden;
      position: relative;
      margin-bottom: 8px;

      &:last-child {
        margin-bottom: 0;
      }

      @media screen and (max-width: 1080px) {
        padding: 12px 24px;
      }

      &:before {
        content: '';
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        background: linear-gradient(180deg, rgba(255, 255, 255, 0.00) 59.16%, rgba(38, 173, 229, 0.17) 100%);

      }

      //@media screen and (min-width: 1240px) {
      //  &:hover {
      //
      //    &.item5 {
      //      transform: scale(1.20);
      //      z-index: 3;
      //    }
      //
      //    &.item4 {
      //      transform: scale(1.20);
      //      z-index: 3;
      //
      //      & ~ .item5 {
      //        transform: scale(1.1);
      //        z-index: 2;
      //      }
      //    }
      //
      //    &.item3 {
      //      transform: scale(1.20);
      //      z-index: 3;
      //
      //      & ~ .item4 {
      //        transform: scale(1.1);
      //        z-index: 2;
      //      }
      //    }
      //
      //    &.item2 {
      //      transform: scale(1.20);
      //      z-index: 3;
      //
      //      & ~ .item3 {
      //        transform: scale(1.1);
      //        z-index: 2;
      //      }
      //    }
      //
      //    &.item1 {
      //      transform: scale(1.20);
      //      z-index: 3;
      //
      //      & ~ .item2 {
      //        transform: scale(1.1);
      //        z-index: 2;
      //      }
      //    }
      //  }
      //
      //  &:has(+ .item:hover) {
      //    transform: scale(1.1);
      //    z-index: 2;
      //  }
      //}

      &:first-child {
        margin-top: 0
      }

      svg {
        display: block;
        width: 33px;
        height: auto;
        margin-right: 24px;
      }

      p {
        font-size: 32px;
        font-family: $bold;
        line-height: 110%;
        color: white;
        @media screen and (max-width: 1080px) {
          font-size: 20px;
        }
      }
    }
  }

  .our-mission {
    margin-top: 88px;
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;

    @media screen and (max-width: 1080px) {
      margin-top: 0;
    }

    .line {
      background: $blue-50;
      width: 100%;
      margin: 4px 0;

      &.line1 {
        height: 12px;
        max-width: calc(100% - 100px);
        margin-bottom: 8px;

        @media screen and (max-width: 1080px) {
          max-width: calc(100% - 50px);
        }
      }

      &.line2 {
        height: 6px;
        max-width: calc(100% - 150px);

        @media screen and (max-width: 1080px) {
          max-width: calc(100% - 76px);
        }
      }

      &.line3 {
        height: 2px;
        max-width: calc(100% - 200px);
        @media screen and (max-width: 1080px) {
          max-width: calc(100% - 104px);
        }
      }
    }

    .blue {
      background: $blue-50;
      padding: 60px;
      @media screen and (max-width: 1080px) {
        padding: 32px;
      }

      h3 {
        text-transform: uppercase;
        font-size: 44px;
        font-family: $bold;
        color: white;
        line-height: 120%;
        margin-bottom: 24px;

        @media screen and (max-width: 1080px) {
          font-size: 32px;
        }
      }

      p {
        font-size: 20px;
        font-family: $bold;
        color: white;
        line-height: 120%;

        @media screen and (max-width: 1080px) {
          font-size: 16px;

        }
      }
    }
  }

  .purpose {
    display: flex;
    flex-direction: column;
    align-items: center;

    margin-bottom: 20px;

    .line {
      background: white;
      width: 100%;
      margin: 4px 0;

      &.line1 {
        margin-top: 0;

        height: 2px;
        max-width: calc(100% - 200px);
        @media screen and (max-width: 1080px) {
          max-width: calc(100% - 104px);
        }
      }

      &.line2 {
        height: 6px;
        max-width: calc(100% - 150px);
        @media screen and (max-width: 1080px) {
          max-width: calc(100% - 76px);
        }
      }

      &.line3 {
        height: 12px;
        max-width: calc(100% - 100px);
        margin-bottom: 8px;
        @media screen and (max-width: 1080px) {
          max-width: calc(100% - 50px);
        }
      }
    }

    .white {
      background: rgba(0, 158, 224, 0.30);

      padding: 80px 60px;

      @media screen and (max-width: 1080px) {
        padding: 32px;
      }

      h3 {
        font-size: 44px;
        font-family: $bold;
        color: #231F20;
        line-height: 120%;
        margin-bottom: 24px;
        letter-spacing: -1.76px;

        @media screen and (max-width: 1080px) {
          letter-spacing: -1.28px;
          font-size: 32px;
        }
      }

      p {
        font-size: 20px;
        font-family: $bold;
        color: #231F20;
        line-height: 120%;
        letter-spacing: -0.8px;
        @media screen and (max-width: 1080px) {
          letter-spacing: -0.64px;
          font-size: 16px;
        }
      }
    }
  }

  .value {
    display: flex;
    flex-direction: column;
    background: var(--Blue-50, #009EE0);

    padding: 60px;
    @media screen and (max-width: 1080px) {
      padding: 32px;
    }

    &__title {
      text-transform: uppercase;
      font-size: 44px;
      font-family: $bold;
      color: white;
      line-height: 120%;
      margin-bottom: 24px;
      text-align: left;

      @media screen and (max-width: 1080px) {
        font-size: 32px;
      }
    }

  }

  .last-line-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .last-line {
    background: $blue-50;
    width: 100%;
    margin: 4px 0;

    &.line1 {
      height: 12px;
      max-width: calc(100% - 100px);
      margin-top: 8px;

      @media screen and (max-width: 1080px) {
        max-width: calc(100% - 50px);
      }
    }

    &.line2 {
      height: 6px;
      max-width: calc(100% - 150px);

      @media screen and (max-width: 1080px) {
        max-width: calc(100% - 76px);
      }
    }

    &.line3 {
      height: 2px;
      max-width: calc(100% - 200px);
      @media screen and (max-width: 1080px) {
        max-width: calc(100% - 104px);
      }
    }
  }

}

#management {
  padding: 0 40px;
  display: flex;
  justify-content: flex-end;
  min-height: calc(((var(--vh, 1vh) * 100) - 79px));
  background: var(--black-10, #F1F1F1);

  @media screen and (max-width: 1080px) {
    justify-content: center;
    padding: 0 20px;
    min-height: 0;
  }

  .content {
    max-width: 600px;
    width: 100%;
    padding-top: 120px;
    padding-bottom: 80px;
    margin: auto 0;

    @media screen and (max-width: 1080px) {
      padding-top: 60px;
      max-width: 380px;
      padding-bottom: 80px;
    }
  }

  h2 {
    color: #63666A;
    font-size: 32px;
    font-family: $bold;
    margin-bottom: 30px;
    text-transform: uppercase;
    letter-spacing: -1.6px;
    @media screen and (max-width: 1080px) {
      font-size: 24px;
    }
  }

  h3 {
    color: var(--black-100, #231F20);
    font-family: $bold;
    font-size: 44px;
    font-style: normal;
    line-height: 100%; /* 44px */
    letter-spacing: -2.2px;
    text-transform: uppercase;
    margin-bottom: 48px;

    @media screen and (max-width: 1080px) {
      font-size: 32px;
      margin-bottom: 0;
    }
  }

  .padding {
    padding: 0 80px;

    @media screen and (max-width: 1080px) {
      padding: 0 0 0 40px;
    }

    h4 {
      margin-bottom: 32px;
      color: var(--Blue-60, #038FD0);
      font-family: $bold;
      font-size: 24px;
      line-height: 100%; /* 24px */
      letter-spacing: -0.72px;
      text-transform: uppercase;

      @media screen and (max-width: 1080px) {
        margin-top: 40px;
        margin-bottom: 16px;
        font-size: 20px;
      }
    }

    p {
      border-top: 2px solid var(--Blue-50, #009EE0);
      padding-top: 32px;
      margin-bottom: 32px;

      color: var(--black-100, #231F20);
      font-family: $bold;
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: 120%; /* 24px */
      &:last-child {
        margin-bottom: 0;
        padding-bottom: 32px;
        border-bottom: 2px solid var(--Blue-50, #009EE0);

      }

      @media screen and (max-width: 1080px) {
        font-size: 18px;
      }
    }
  }
}

#products {
  padding: 0 40px;
  display: flex;
  justify-content: flex-end;
  background: white;
  min-height: calc(((var(--vh, 1vh) * 100) - 79px));

  @media screen and (max-width: 1080px) {
    justify-content: center;
    padding: 0 20px;
    min-height: 0;
  }

  .content {
    max-width: 600px;
    width: 100%;
    padding-top: 120px;
    padding-bottom: 80px;
    margin: auto 0;

    @media screen and (max-width: 1080px) {
      padding-top: 80px;
      max-width: 380px;
      padding-bottom: 0;
    }
  }

  h2 {
    color: #63666A;
    font-size: 32px;
    font-family: $bold;
    margin-bottom: 30px;
    text-transform: uppercase;
    letter-spacing: -1.6px;
    @media screen and (max-width: 1080px) {
      font-size: 24px;
    }
  }

  h3 {
    color: var(--black-100, #231F20);
    font-family: $bold;
    font-size: 44px;
    font-style: normal;
    line-height: 100%; /* 44px */
    letter-spacing: -2.2px;
    text-transform: uppercase;
    @media screen and (max-width: 1080px) {
      font-size: 32px;
      max-width: 210px;
    }
  }

  h4 {
    color: var(--Blue-60, #038FD0);
    text-align: right;
    font-family: $bold;
    font-size: 24px;
    font-style: normal;
    line-height: 100%; /* 24px */
    letter-spacing: -0.72px;
    text-transform: uppercase;
    margin-bottom: 22px;
    @media screen and (max-width: 1080px) {
      font-size: 20px;
      max-width: 180px;
      margin: 0 0 30px auto;
    }
  }

  .btn {
    margin-top: 30px;
    padding: 18px 29px;
    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 44px;
    background: #EB305D;

    color: var(--White, #FFF);
    font-family: $bold;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 100%;
    letter-spacing: -0.24px;
    text-transform: uppercase;

    text-decoration: none;

    max-width: 184px;
    width: 100%;
    will-change: background;
    transition: background .2s ease;

    &.mb {
      margin-bottom: 30px;
    }

    &.mob {
      display: none;
      @media screen and (max-width: 1080px) {
        display: flex;
      }
    }

    &.desk {
      @media screen and (max-width: 1080px) {
        display: none;
      }
    }

    @media screen and (max-width: 1080px) {
      margin: 24px auto 0 auto;
    }

    @media screen and (min-width: 1024px) {
      &:hover {
        background: #FD6589;
      }
    }

    &:active {
      background: #FD6589;
    }
  }

  .item-wrapper {
    display: flex;
    flex-direction: column;

    .item {
      padding: 50px 60px;
      background: #F1F1F1;
      display: flex;
      flex-direction: column;
      margin-bottom: 8px;
      @media screen and (max-width: 1240px) {
        padding: 32px;
      }

      &:last-child {
        margin-bottom: 0;
      }

      .icon {
        max-width: 90px;
        min-width: 90px;
        width: 100%;
        margin-right: 24px;
        margin-bottom: 16px;


        svg {
          width: 100%;
          height: auto;
          display: block;
        }
      }

      .text-wrapper {
        display: flex;
        align-items: center;

        @media screen and (max-width: 1080px) {
          flex-direction: column;
          align-items: flex-start;
        }
      }

      .text {
        color: #231F20;
        font-size: 20px;
        line-height: 120%;
        font-family: $bold;
        @media screen and (max-width: 1080px) {
          font-size: 18px;
        }

        .color {
          color: #038FD0;
        }

        &.mb {
          margin-bottom: 35px;
        }

        .big {
          letter-spacing: -0.72px;
          font-size: 24px;
          color: #231F20;
          text-transform: uppercase;
          @media screen and (max-width: 1080px) {
            font-size: 20px;
            letter-spacing: 0;
          }
        }
      }
    }
  }
}

#carbon-statement {
  padding: 0 40px;
  display: flex;
  justify-content: flex-end;
  background: white;
  min-height: calc(((var(--vh, 1vh) * 100) - 79px));

  @media screen and (max-width: 1080px) {
    justify-content: center;
    padding: 0 20px;
    min-height: 0;
  }

  .content {
    max-width: 600px;
    width: 100%;
    padding-top: 120px;
    padding-bottom: 80px;
    margin: auto 0;

    @media screen and (max-width: 1080px) {
      padding-top: 80px;
      max-width: 380px;
      padding-bottom: 0;
    }
  }

  h2 {
    color: #63666A;
    font-size: 32px;
    font-family: $bold;
    margin-bottom: 30px;
    text-transform: uppercase;
    letter-spacing: -1.6px;
    @media screen and (max-width: 1080px) {
      font-size: 24px;
    }
  }

  h3 {
    color: var(--black-100, #231F20);
    font-family: $bold;
    font-size: 44px;
    font-style: normal;
    line-height: 100%; /* 44px */
    letter-spacing: -2.2px;
    text-transform: uppercase;
    margin-bottom: 52px;
    @media screen and (max-width: 1080px) {
      margin-bottom: 32px;
      font-size: 32px;
    }
  }


  .padding {
    padding: 0 80px;

    @media screen and (max-width: 1080px) {
      padding: 0 0 0 40px;
    }

    h4 {
      color: var(--Blue-60, #038FD0);
      font-family: $bold;
      font-size: 24px;
      font-style: normal;
      font-weight: 700;
      line-height: 120%;
      letter-spacing: -0.72px;
      text-transform: uppercase;
      margin-bottom: 12px;

      @media screen and (max-width: 1080px) {
        font-size: 20px;
      }
    }

    .text-black {
      color: var(--black-100, #231F20);
      font-family: $bold;
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: 120%;
      margin-bottom: 32px;
      @media screen and (max-width: 1080px) {
        font-size: 18px;
      }
    }

    .list-title {
      padding-top: 32px;
      border-top: 2px solid var(--Blue-50, #009EE0);
      color: var(--black-100, #231F20);
      font-family: $bold;
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: 120%;
      letter-spacing: -0.54px;
      margin-bottom: 10px;
      @media screen and (max-width: 1080px) {
        font-size: 16px;
      }

      i {
        font-style: italic;
      }

      &.no-border {
        border: none;
        padding-top: 28px;
      }
    }

    .reg-text {
      color: var(--black-100, #231F20);
      font-family: $reg;
      font-size: 16px;
      font-style: normal;
      line-height: 120%;
      letter-spacing: -0.48px;

      a {
        color: var(--Blue-80, #115391);
        font-family: $reg;
        font-size: 16px;
        font-style: italic;
        font-weight: 400;
        line-height: 120%;
        text-decoration: none;

        @media screen and (min-width: 1024px) {
          &:hover {
            cursor: pointer;
            text-decoration: underline;
          }
        }
      }

      i {
        font-style: italic;
      }
    }

    ul {
      padding-left: 18px;

      li {
        list-style: decimal;
        color: var(--Blue-60, #038FD0);
        font-family: $bold;
        font-size: 16px;
        font-style: normal;
        line-height: 120%;
        letter-spacing: -0.48px;
        margin-bottom: 10px;

        &:last-child {
        }

        .black {
          font-family: $reg;
          color: var(--black-100, #231F20);
        }
      }
    }
  }
}

#slavery-statement-2024 {
  padding: 0 40px;
  display: flex;
  justify-content: flex-end;
  background: white;
  min-height: calc(((var(--vh, 1vh) * 100) - 79px));

  @media screen and (max-width: 1080px) {
    justify-content: center;
    padding: 0 20px;
    min-height: 0;
  }

  .content {
    max-width: 600px;
    width: 100%;
    padding-top: 120px;
    padding-bottom: 80px;
    margin: auto 0;

    @media screen and (max-width: 1080px) {
      padding-top: 80px;
      max-width: 380px;
      padding-bottom: 8 0px;
    }
  }

  h2 {
    color: #63666A;
    font-size: 32px;
    font-family: $bold;
    margin-bottom: 30px;
    text-transform: uppercase;
    letter-spacing: -1.6px;
    @media screen and (max-width: 1080px) {
      font-size: 24px;
    }
  }

  h3 {
    color: var(--black-100, #231F20);
    font-family: $bold;
    font-size: 44px;
    font-style: normal;
    line-height: 100%; /* 44px */
    letter-spacing: -2.2px;
    text-transform: uppercase;
    margin-bottom: 52px;
  }


  .padding {
    padding: 0 80px;
    @media screen and (max-width: 1080px) {
      padding: 0 0 0 40px;
    }

    h4 {
      color: var(--Blue-60, #038FD0);
      font-family: $bold;
      font-size: 24px;
      font-style: normal;
      font-weight: 700;
      line-height: 120%;
      letter-spacing: -0.72px;
      text-transform: uppercase;
      margin-bottom: 12px;
      @media screen and (max-width: 1080px) {
        font-size: 20px;
      }
    }

    .text-black {
      color: var(--black-100, #231F20);
      font-family: $bold;
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: 120%;
      margin-bottom: 32px;
      @media screen and (max-width: 1080px) {
        font-size: 18px;
      }
    }

    .list-title {
      padding-top: 32px;
      border-top: 2px solid var(--Blue-50, #009EE0);
      color: var(--black-100, #231F20);
      font-family: $bold;
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: 120%;
      letter-spacing: -0.54px;
      margin-bottom: 10px;
      @media screen and (max-width: 1080px) {
        font-size: 16px;
      }

      i {
        font-style: italic;
      }

      &.no-border {
        border: none;
        padding-top: 28px;
      }
    }

    .reg-text {
      color: var(--black-100, #231F20);
      font-family: $reg;
      font-size: 16px;
      font-style: normal;
      line-height: 120%;
      letter-spacing: -0.48px;

      &.mb {
        margin-bottom: 10px;
      }

      i {
        font-style: italic;
      }
    }

    ul {
      padding-left: 18px;

      li {
        list-style: decimal;
        color: var(--Blue-60, #038FD0);
        font-family: $bold;
        font-size: 16px;
        font-style: normal;
        line-height: 120%;
        letter-spacing: -0.48px;
        margin-bottom: 10px;

        &:last-child {
          margin-bottom: 0;
        }

        .black {
          font-family: $reg;
          color: var(--black-100, #231F20);
        }
      }
    }
  }
}

#contact {
  padding: 0 40px;

  display: flex;
  justify-content: flex-end;

  background: $blue-50;

  min-height: calc(((var(--vh, 1vh) * 100) - 79px));

  @media screen and (max-width: 1080px) {
    justify-content: center;
    padding: 0 20px;
    min-height: 0;
  }

  .content {
    max-width: 600px;
    width: 100%;
    padding-top: 120px;
    padding-bottom: 80px;

    display: flex;
    flex-direction: column;

    @media screen and (max-width: 1080px) {
      padding-top: 60px;
      padding-bottom: 20px;
      max-width: 380px;
    }

    h2 {
      display: block;
      color: white;
      font-family: $bold;

      @media screen and (max-width: 1080px) {
        margin: 0 0 32px 0;
      }

      span {
        display: flex;
      }

      .line1 {
        display: block;
        color: var(--White, #FFF);
        font-family: $bold;
        font-size: 44px;
        font-style: normal;
        line-height: 100%; /* 44px */
        letter-spacing: -2.2px;
        text-transform: uppercase;

        @media screen and (max-width: 1080px) {
          font-size: 32px;
        }
      }
    }

    .contact-info {
      display: grid;
      margin-top: 96px;

      display: grid;
      grid-template-rows: 1fr 1fr 1fr;
      grid-template-columns: 1fr 1fr;
      gap: 48px 40px;

      @media screen and (max-width: 1080px) {
        display: flex;
        flex-direction: column;
        gap: 0;
        margin-top: 0;
      }

      .item {
        display: flex;
        flex-direction: column;


        @media screen and (max-width: 1080px) {
          margin-bottom: 48px;
          &:last-child {
            margin-bottom: 0;
          }
        }

        h3 {
          color: var(--White, #FFF);
          font-family: $bold;
          font-size: 24px;
          font-style: normal;
          line-height: 110%;
          letter-spacing: -0.72px;
          text-transform: uppercase;
          margin-bottom: 8px;
          @media screen and (max-width: 1080px) {
            font-size: 20px;
            br {
              display: none;
            }
          }
        }

        a {
          text-decoration: none;
          margin-bottom: 3px;
          color: var(--White, #FFF);
          font-family: $reg;
          font-size: 16px;
          font-style: normal;
          line-height: 120%;
          letter-spacing: -0.48px;

          &:last-child {
            margin-bottom: 0;
          }

          @media screen and (min-width: 1024px) {

            &:hover {
              text-decoration: underline;
            }
          }
        }
      }
    }

    .contact-bottom {
      margin: auto 0 0 0;
      max-width: 600px;
      width: 100%;
      background: rgba(0, 158, 224, 0.50);
      padding-top: 64px;
      padding-bottom: 20px;
      position: relative;

      &.mob {
        display: none;
        @media screen and (max-width: 1024px) {
          display: block;
        }
      }

      .mark {
        width: 16px;
        height: 16px;

        background: $crimson;
        border-radius: 50%;
        margin-bottom: 15px;
      }

      .line {
        width: 100%;
        padding-bottom: 16px;
        margin-bottom: 24px;
        border-bottom: 2px solid $white;

        display: flex;
        flex-direction: column;

        &.active {
          justify-content: center;
        }

        &:last-child {
          border-bottom: 0;
          padding-bottom: 0;
          margin-bottom: 0;
        }
      }

      .address {
        color: $white;
        font-size: 16px;
        font-family: $reg;
        line-height: 120%;
        //letter-spacing: -0.04em;
        margin-right: 15px;
      }

      .mail {
        margin-top: 32px;
        border: 2px solid rgba(255, 255, 255, 0);
        transition: border-color .2s ease;
        border-radius: 44px;
        padding: 17px 35px;

        text-decoration: none;
        color: $white;
        font-size: 14px;
        font-family: $bold;
        text-transform: uppercase;
        background: rgba(255, 255, 255, 0.2);

        letter-spacing: -0.02em;

        height: 52px;

        display: flex;
        justify-content: center;
        align-items: center;

        &.active {
          font-size: 22px;
          height: 66px;
          padding: 22px 40px;

        }

        @media screen and (max-width: 1280px) {
          padding: 12px 20px;
          height: 48px;
        }

        @media screen and (min-width: 1240px) {
          &:hover {
            border-color: $white;
          }
        }
      }

      .sales-mail {
        position: relative;
        font-size: 18px;
        line-height: 120%;
        font-family: $bold;
        color: $white;

        display: inline-flex;
        align-items: center;
        text-decoration: none;
        //letter-spacing: -0.04em;
        p {
          display: flex;
          align-items: center;
          transition: transform .2s ease;
        }

        @media screen and (min-width: 1240px) {
          &:hover {
            p {
              transform: translateY(-2px);
            }
          }
        }

        svg {
          display: block;
          width: 21px;
          height: auto;
          margin-left: 10px;
        }

        &:before {
          content: '';
          width: 100%;
          height: 2px;
          bottom: -4px;
          left: 0;
          right: 0;
          position: absolute;

          background: $white;
        }
      }
    }
  }

}

</style>
